import React, { Component } from 'react';
import {
    SearchSucursalModal,
    PartnerCreateModal,
    ListModal,
    SeriesModal,
    RelationPMBA,
    StandardSelectModal
} from "./index";
import { connect } from 'react-redux';
import { DISPATCH_ID, Modules, decodeText } from '../libs/utils/Const';
import $ from 'jquery';
import '../css/responsive.css'
import Select from 'react-select';

class SucursalModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showActCodeCNModal: false,
            actCodeCNModalAction: () => { },
        };
    }

    refreshModel = (sucursalModel) => {
        const { refreshModel } = this.props;
        refreshModel(sucursalModel);
    };

    RefreshNewPayMethod = (PayMethodModel) => {
        const { RefreshPayMethodModel } = this.props;
        RefreshPayMethodModel(PayMethodModel);
    }

    CreateSucursal = () => {
        const { sendModel, sucursalModel } = this.props;

        sendModel(sucursalModel);
    };

    cancelEditMode = () => {
        const { cancelEditMode } = this.props;
        cancelEditMode();
    };

    AcceptEditMode = () => {
        const { acceptEditMode, sucursalModel } = this.props;
        acceptEditMode(sucursalModel);
    };

    GetSucursales = async () => {
        const { OpenSearchSucursalModal } = this.props;
        OpenSearchSucursalModal();
    };

    ChangeNombre = event => {
        const { sucursalModel } = this.props;
        sucursalModel.Nombre = event.nativeEvent.target.value;
        this.refreshModel(sucursalModel);
    };

    ChangeDireccion = event => {
        const { sucursalModel } = this.props;
        sucursalModel.Direccion = event.nativeEvent.target.value;
        this.refreshModel(sucursalModel);
    };

    ChangeCodeBO = event => {
        const { notificationReducer: { showAlert } } = this.props;
        const { sucursalModel } = this.props;

        sucursalModel.Code = event.nativeEvent.target.value;
        if (sucursalModel.Code.length > 3) {
            showAlert({ type: 'info', message: 'EL CÓDIGO SOLO PUEDE TENER 3 CARACTERES ALFANUMÉRICOS', timeOut: 5000 });
            return;
        }

        this.refreshModel(sucursalModel);
    };

    ChangeCp = event => {
        const { sucursalModel } = this.props;
        sucursalModel.Cp = event.nativeEvent.target.value;
        this.refreshModel(sucursalModel);
    };

    ChangeTelefono = event => {
        const { sucursalModel } = this.props;
        sucursalModel.Telefono = event.nativeEvent.target.value;
        this.refreshModel(sucursalModel);
    };

    ChangeClientes = value => {
        const { sucursalModel } = this.props;
        sucursalModel.Clientes = value;
        this.refreshModel(sucursalModel);
    };

    ChangeListaPrecios = event => {
        const { sucursalModel } = this.props;
        sucursalModel.ListaPrecios = event.nativeEvent.target.value;
        this.refreshModel(sucursalModel);
    };

    ChangeAlmacen = event => {
        const { sucursalModel } = this.props;
        sucursalModel.Almacen = event.nativeEvent.target.value;
        this.refreshModel(sucursalModel);
    };

    ChangeProject = event => {
        const { sucursalModel } = this.props;
        if (event && event.value !== undefined) {
            sucursalModel.Project = event.value;
        }
        else if (event && event.nativeEvent && event.nativeEvent.target) {
            sucursalModel.Project = event.nativeEvent.target.value;
        }
        else {
            sucursalModel.Project = '';
        }
        this.refreshModel(sucursalModel);
    };
    //IS BORDER
    ChangeisBorder = event => {
        const { sucursalModel } = this.props;
        sucursalModel.isBorder = event.nativeEvent.target.value;
        this.refreshModel(sucursalModel);
    };

    // TIME ZONE
    ChangeTimeZone = event => {
        const { sucursalModel } = this.props;
        sucursalModel.TimeZone = event.nativeEvent.target.value;
        this.refreshModel(sucursalModel);
    };

    ChangeType = event => {
        const { sucursalModel } = this.props;
        sucursalModel.Type = event.nativeEvent.target.value;
        this.refreshModel(sucursalModel);
    };

    ChangeGender = event => {
        const { sucursalModel } = this.props;
        sucursalModel.Gender = event.nativeEvent.target.value;
        this.refreshModel(sucursalModel);
    };

    ChangeMobilePhone = event => {
        const { sucursalModel } = this.props;
        sucursalModel.MobilePhone = event.nativeEvent.target.value;
        this.refreshModel(sucursalModel);
    };

    PartnerModal = async () => {
        const { OpenPartnerModal } = this.props;
        await OpenPartnerModal();
    };

    Delete = async (index) => {
        const { DeletePartner } = this.props;
        DeletePartner(index);
    };

    ChangeSeriesOQUT = event => {
        const { sucursalModel } = this.props;
        sucursalModel.U_FMB_ValidateSeriesOQUT = event.nativeEvent.target.value;
        this.refreshModel(sucursalModel);
    };

    ChangeSeriesORDR = event => {
        const { sucursalModel } = this.props;
        sucursalModel.U_FMB_ValidateSeriesORDR = event.nativeEvent.target.value;
        this.refreshModel(sucursalModel);
    };

    ChangeSeriesODLN = event => {
        const { sucursalModel } = this.props;
        sucursalModel.U_FMB_ValidateSeriesODLN = event.nativeEvent.target.value;
        this.refreshModel(sucursalModel);
    };

    ChangeSeriesOINV = event => {
        const { sucursalModel } = this.props;
        sucursalModel.U_FMB_ValidateSeriesOINV = event.nativeEvent.target.value;
        this.refreshModel(sucursalModel);
    };

    ChangeSeriesORDN = event => {
        const { sucursalModel } = this.props;
        sucursalModel.U_FMB_ValidateSeriesORDN = event.nativeEvent.target.value;
        this.refreshModel(sucursalModel);
    };

    ChangeSeriesDN = event => {
        const { sucursalModel } = this.props;
        sucursalModel.U_FMB_ValidateSeriesDN = event.nativeEvent.target.value;
        this.refreshModel(sucursalModel);
    };

    ChangeSeriesORIN = event => {
        const { sucursalModel } = this.props;
        sucursalModel.U_FMB_ValidateSeriesORIN = event.nativeEvent.target.value;
        this.refreshModel(sucursalModel);
    };

    ChangeSeriesOPOR = event => {
        const { sucursalModel } = this.props;
        sucursalModel.U_FMB_ValidateSeriesOPOR = event.nativeEvent.target.value;
        this.refreshModel(sucursalModel);
    };

    ChangeSeriesOPDN = event => {
        const { sucursalModel } = this.props;
        sucursalModel.U_FMB_ValidateSeriesOPDN = event.nativeEvent.target.value;
        this.refreshModel(sucursalModel);
    };

    ChangeSeriesORPD = event => {
        const { sucursalModel } = this.props;
        sucursalModel.U_FMB_ValidateSeriesORPD = event.nativeEvent.target.value;
        this.refreshModel(sucursalModel);
    };

    ChangeSeriesOPCH = event => {
        const { sucursalModel } = this.props;
        sucursalModel.U_FMB_ValidateSeriesOPCH = event.nativeEvent.target.value;
        this.refreshModel(sucursalModel);
    };

    ChangeSeriesORPC = event => {
        const { sucursalModel } = this.props;
        sucursalModel.U_FMB_ValidateSeriesORPC = event.nativeEvent.target.value;
        this.refreshModel(sucursalModel);
    };

    ChangeSeriesORCT = event => {
        const { sucursalModel } = this.props;
        sucursalModel.U_FMB_ValidateSeriesORCT = event.nativeEvent.target.value;
        this.refreshModel(sucursalModel);
    };

    ChangeSeriesOVPM = event => {
        const { sucursalModel } = this.props;
        sucursalModel.U_FMB_ValidateSeriesOVPM = event.nativeEvent.target.value;
        this.refreshModel(sucursalModel);
    };

    ChangeSeriesOWTR = event => {
        const { sucursalModel } = this.props;
        sucursalModel.U_FMB_ValidateSeriesOWTR = event.nativeEvent.target.value;
        this.refreshModel(sucursalModel);
    };

    ChangeSeriesOWTQ = event => {
        const { sucursalModel } = this.props;
        sucursalModel.U_FMB_ValidateSeriesOWTQ = event.nativeEvent.target.value;
        this.refreshModel(sucursalModel);
    };

    ChangeSeriesOIGN = event => {
        const { sucursalModel } = this.props;
        sucursalModel.U_FMB_ValidateSeriesOIGN = event.nativeEvent.target.value;
        this.refreshModel(sucursalModel);
    };

    ChangeSeriesOIGE = event => {
        const { sucursalModel } = this.props;
        sucursalModel.U_FMB_ValidateSeriesOIGE = event.nativeEvent.target.value;
        this.refreshModel(sucursalModel);
    };

    ChangeSeriesOPRQ = event => {
        const { sucursalModel } = this.props;
        sucursalModel.U_FMB_ValidateSeriesOPRQ = event.nativeEvent.target.value;
        this.refreshModel(sucursalModel);
    };

    ChangeSeriesOMRV = event => {
        const { sucursalModel } = this.props;
        sucursalModel.U_FMB_ValidateSeriesOMRV = event.nativeEvent.target.value;
        this.refreshModel(sucursalModel);
    };

    //-----
    DeleteWhsLine = (index) => {
        const { DeleteWhsLine } = this.props;
        DeleteWhsLine(index);
    }

    OnchangeOutMarch = (value) => {
        const { sucursalModel } = this.props;
        sucursalModel.U_FMB_DEF_PLInventoryGenExitService = value;
        this.refreshModel(sucursalModel);
    }

    ChangePLPrintTags = (value) => {
        const { sucursalModel } = this.props;
        sucursalModel.U_FMB_PLPrintTags = value;
        this.refreshModel(sucursalModel);
    }

    OnchangeEntryMarch = (value) => {
        const { sucursalModel } = this.props;
        sucursalModel.U_FMB_DEF_PLInventoryGenEntryService = value;
        this.refreshModel(sucursalModel);
    }

    ChangePLStockTransfer = (value) => {
        const { sucursalModel } = this.props;
        sucursalModel.U_FMB_DEF_PLStockTransfer = value;
        this.refreshModel(sucursalModel);
    }

    ChangePLReqStockTransfer = (value) => {
        const { sucursalModel } = this.props;
        sucursalModel.U_FMB_DEF_PLReqStockTransfer = value;
        this.refreshModel(sucursalModel);
    }

    ShowAddPayMethod = (boolValue) => {
        const { ShowAddPayMethod } = this.props
        ShowAddPayMethod(boolValue)
    }

    ChangeCodeNewPayMethod = (value) => {
        const { PayMethodModel } = this.props
        PayMethodModel.code = value;
        this.RefreshNewPayMethod(PayMethodModel);
    }

    ChangeNameNewPayMethod = (value) => {
        const { PayMethodModel } = this.props
        PayMethodModel.name = value;
        this.RefreshNewPayMethod(PayMethodModel);
    }

    ChangeTypePayMethod = (value) => {
        const { PayMethodModel } = this.props
        PayMethodModel.type = value;
        this.RefreshNewPayMethod(PayMethodModel);
        if (Number(value) === 14) {
            this.ChangeCodeNewPayMethod('NC');
            this.ChangeNameNewPayMethod('Nota de crédito');
        } else if (Number(value) === -1) {
            this.ChangeCodeNewPayMethod('CD');
            this.ChangeNameNewPayMethod('Crédito');
        } else if (Number(value) !== 6 || Number(value) !== 5) {
            this.ChangeCodeNewPayMethod('');
            this.ChangeNameNewPayMethod('');
        }
    }

    ChangeCard = (value) => {
        const { PayMethodModel } = this.props
        PayMethodModel.idCard = value;
        this.RefreshNewPayMethod(PayMethodModel);
    }

    CleanPayModel = () => {
        const { PayMethodModel } = this.props
        PayMethodModel.name = '';
        PayMethodModel.code = '';
        PayMethodModel.type = '';
        this.RefreshNewPayMethod(PayMethodModel);
    }

    ChangeTipoUsoPayMethod = (index, value) => {
        const { sucursalModel } = this.props;
        sucursalModel.ListPayMethods[index].TipoUso = value;
        this.refreshModel(sucursalModel);
    };

    //--
    ChangeLimitLines = (value) => {
        const { notificationReducer: { showAlert } } = this.props;
        const { sucursalModel } = this.props;
        if (isNaN(value)) {
            showAlert({ type: 'error', message: 'Ingresa un valor numérico ', timeOut: 5000 });
            return;
        }
        sucursalModel.LimitLines = value;
        this.refreshModel(sucursalModel);
    }

    ChangePLPriceMin = (value) => {
        const { sucursalModel } = this.props;
        sucursalModel.U_FMB_DEF_PLPriceMin = value;
        this.refreshModel(sucursalModel);
    }

    ChangePLBasePrice = (value) => {
        const { sucursalModel } = this.props;
        sucursalModel.U_FMB_DEF_PLBasePrice = value;
        this.refreshModel(sucursalModel);
    }

    ChangeManagerEmail = event => {
        const { sucursalModel } = this.props;
        sucursalModel.manager_Email = event.nativeEvent.target.value;
        this.refreshModel(sucursalModel);
    };

    openActCodeCNandRTModal = async (type = 0) => {
        const { enableSpinner } = this.props;
        enableSpinner(true);
        const action = type === 0 ? this.selectActCodeCN : this.selectActCodeRT;
        await this.setState({
            showActCodeCNModal: true,
            actCodeCNModalAction: action,
        });
        $("#selectActCodeCN").modal("show");
        $("#selectActCodeCN").on("hidden.bs.modal", async () => {
            await this.setState({
                showActCodeCNModal: false,
                actCodeCNModalAction: () => { },
            });
        });
        enableSpinner(false);
    }

    selectActCodeCN = (ActData) => {
        const { sucursalModel } = this.props;
        sucursalModel.ActCodeCN = ActData.AcctCode;
        sucursalModel.ActNameCN = ActData.AcctName;
        this.refreshModel(sucursalModel);
        $("#selectActCodeCN").modal("hide");
    }

    selectActCodeRT = (ActData) => {
        const { sucursalModel } = this.props;
        sucursalModel.ActCodeRT = ActData.AcctCode;
        sucursalModel.ActNameRT = ActData.AcctName;
        this.refreshModel(sucursalModel);
        $("#selectActCodeCN").modal("hide");
    }

    render() {
        const {
            action,
            editMode,
            showSearchSucursalModal,
            sucursales,
            SearchSucursal,
            CloseSearchSucursalModal,
            partners,
            pageTotal,
            SelectPartner,
            RefreshPartner,
            cleanData,
            showSeriesModal,
            SaveSeries,
            CloseSeriesModal,
            sucursalModel,
            checkbox,
            Accounts,
            PaymentMethods,
            RefreshRelationModel,
            RelationModel,
            AddRelation,
            DeleteAccountRelations,
            AccountsRelated,
            AddRelationsToSucursal,
            AddPayMethod
        } = this.props;
        const {
            showActCodeCNModal,
            actCodeCNModalAction,
        } = this.state;

        return (
            <div>

                <div className="modal-body">
                    {this.renderEditButton()}
                    {this.renderSucursalHeader()}
                    {this.renderSucursalBody()}
                </div>
                <div className="modal-footer">
                    {action === 2 && editMode && (
                        <button type="button" className="btn botonCerrar" onClick={this.cancelEditMode}>
                            Cancelar
                        </button>
                    )}
                    {action === 1 &&
                        <button type="button" className="btn botonCorrect text-black" onClick={this.CreateSucursal}>
                            Crear Sucursal
                        </button>}
                    {action === 2 && editMode && (
                        <button type="button" className="btn botonCorrect" onClick={this.AcceptEditMode}>
                            Guardar
                        </button>
                    )}

                    {/* {action === 2 && editMode && (
                                <button type="button" className="btn btn-danger" onClick={this.OpenAreYouAgreeModal}>
                                    Eliminar
                                </button>
                            )} */}

                </div>

                {showSearchSucursalModal &&
                    <SearchSucursalModal
                        sucursales={sucursales}
                        SearchSucursal={SearchSucursal}
                        CloseSearchSucursalModal={CloseSearchSucursalModal}
                    />
                }

                {partners.length > 0 &&
                    <PartnerCreateModal
                        data={partners}
                        type={'C'}
                        totalPage={pageTotal}
                        selectPartner={SelectPartner}
                        cleanData={cleanData}
                        refreshPartner={RefreshPartner}
                    />
                }


                {showSeriesModal &&
                    <SeriesModal
                        action={action}
                        adminUsersModel={sucursalModel}
                        checkbox={checkbox}
                        editMode={editMode}
                        SaveSeries={SaveSeries}
                        CloseSeriesModal={CloseSeriesModal}
                    />
                }

                <RelationPMBA
                    Accounts={Accounts}
                    PaymentMethods={PaymentMethods}
                    RelationModel={RelationModel}
                    AccountsRelated={AccountsRelated}
                    RefreshRelationModel={RefreshRelationModel}
                    AddRelationsToSucursal={AddRelationsToSucursal}
                    AddRelation={AddRelation}
                    DeleteAccountRelations={DeleteAccountRelations}
                    SucursalModel={sucursalModel}
                    AddPayMethod={AddPayMethod}

                />
                <ListModal
                    IdModal={"newPayMethod"}
                    HeaderTitle={'Agregar método de pago'}
                    Body={this.bodyAddPaymentMethod()}
                    CloseActions={() => {
                        this.CleanPayModel();
                        AddPayMethod(false);
                    }}
                    Footer={this.footerAddPayMehtod()}
                />
                {showActCodeCNModal &&
                    <StandardSelectModal
                        id="selectActCodeCN"
                        title="Cuenta de Mayor para Notas de Crédito"
                        data={Accounts}
                        selectAction={actCodeCNModalAction}

                        headers={[
                            { title: "N° Cuenta", value: true, filter: true, field: "AcctCode", format: null, classes: "text-left" },
                            { title: "Descripción", value: true, filter: true, field: "AcctName", format: null, classes: "text-left" },
                        ]}
                        actPos="start" />
                }
            </div>
        );
    }

    renderEditButton = () => {
        const { AcceptEdit, action, editMode, CleanInfo, writeAccess } = this.props;
        if (action === 2 && !editMode) {
            return (
                <>
                    <button
                        type="button"
                        style={{ backgroundColor: 'transparent', color: '#000' }}
                        className="btn"
                        onClick={CleanInfo}>
                        <i className="fa fa-refresh" />
                        Limpiar información
                    </button>
                    {writeAccess &&
                        <button
                            type="button"
                            style={{ backgroundColor: 'transparent', color: '#000' }}
                            className="btn"
                            onClick={AcceptEdit}>
                            <i className="fas fa-edit  fa-lg" />
                            Editar
                        </button>
                    }

                </>
            );
        }
    };

    renderSucursalHeader = () => {
        const { action, editMode, sucursalModel, projects } = this.props;
        const projectOptions = projects ? projects.map(project => ({
            value: project.PrjCode,
            label: `${project.PrjCode} - ${project.PrjName}`
        })) : [];
        return (
            <div className="row" style={{ paddingRight: 0 }} autoComplete="off">
                {/*PRIMER COLUMNA*/}
                <div className="col-12 col-md-6">
                    {/*NOMBRE DE LA SUCURSAL*/}
                    <div className="input-group mb-3">
                        <div className="input-group-prepend">
                            <span className="input-group-text font-weight-bold" id="basic-addon1">Nombre</span>
                        </div>
                        <input type="text" className="form-control"
                            style={{ backgroundColor: 'transparent', borderColor: '#ced4da', color: '#000' }}
                            id="Sucur_Nombre"
                            disabled={(action === 2 && !editMode) ? true : false}
                            onChange={this.ChangeNombre}
                            value={sucursalModel.Nombre ? sucursalModel.Nombre : ""} />
                        <button
                            type="button"
                            style={{ backgroundColor: 'transparent', color: '#EABF28' }}
                            className="input-group-text"
                            data-toggle="modal" data-target="#searchSucursalModal"
                            disabled={(action === 2 && !editMode) ? true : false}
                            onClick={this.GetSucursales}
                        >
                            <i className="fa fa-search" aria-hidden="true" />
                        </button>
                    </div>
                    {/*Code SUCURSAL */}
                    <div className="input-group mb-3">
                        <div className="input-group-prepend">
                            <span className="input-group-text font-weight-bold" id="basic-addon1">Código</span>
                        </div>
                        <input type="text" className="form-control"
                            style={{ backgroundColor: 'transparent', borderColor: '#ced4da', color: '#000' }}
                            disabled={(action === 2 && !editMode) ? true : false}
                            onChange={this.ChangeCodeBO}
                            value={sucursalModel.Code ? sucursalModel.Code : ""} />
                    </div>
                    {/*DIRECCIÓN DE LA SUCURSAL*/}
                    <div className="input-group mb-3">
                        <div className="input-group-prepend">
                            <span className="input-group-text font-weight-bold" id="basic-addon1">Dirección</span>
                        </div>
                        <input type="text" className="form-control"
                            style={{ backgroundColor: 'transparent', borderColor: '#ced4da', color: '#000' }}
                            id="Sucur_Direccion"
                            disabled={(action === 2 && !editMode) ? true : false}
                            onChange={this.ChangeDireccion}
                            value={sucursalModel.Direccion ? sucursalModel.Direccion : ""} />
                    </div>
                    {/*CÓDIGO POSTAL DE LA SUCURSAL*/}
                    <div className="input-group mb-3">
                        <div className="input-group-prepend">
                            <span className="input-group-text font-weight-bold" id="basic-addon1">
                                <span className="d-none d-xl-inline">Código postal</span>
                                <span className="d-inline d-xl-none">C. Postal</span>
                            </span>
                        </div>
                        <input type="text" className="form-control"
                            style={{ backgroundColor: 'transparent', borderColor: '#ced4da', color: '#000' }}
                            id="Sucur_Cp"
                            disabled={(action === 2 && !editMode) ? true : false}
                            onChange={this.ChangeCp}
                            value={sucursalModel.Cp ? sucursalModel.Cp : ""} />
                    </div>
                    {/* CORREO ENCARGADO SUCURSAL */}
                    <div className="input-group mb-3">
                        <div className="input-group-prepend">
                            <span className="input-group-text font-weight-bold" id="basic-addon1">
                                <span className="d-none d-xl-inline">Correo representante</span>
                                <span className="d-inline d-xl-none">Correo</span>
                            </span>
                        </div>
                        <input type="text" className="form-control"
                            style={{ backgroundColor: 'transparent', borderColor: '#ced4da', color: '#000' }}
                            id="Sucur_Cp"
                            disabled={(action === 2 && !editMode) ? true : false}
                            onChange={this.ChangeManagerEmail}
                            value={sucursalModel.manager_Email ? sucursalModel.manager_Email : ""} />
                    </div>
                    {/*TELÉFONO DE LA SUCURSAL*/}
                    <div className="input-group mb-3">
                        <div className="input-group-prepend">
                            <span className="input-group-text font-weight-bold" id="basic-addon1">Teléfono</span>
                        </div>
                        <input type="text" className="form-control"
                            style={{ backgroundColor: 'transparent', borderColor: '#ced4da', color: '#000' }}
                            id="Sucur_Telefono"
                            disabled={(action === 2 && !editMode) ? true : false}
                            onChange={this.ChangeTelefono}
                            value={sucursalModel.Telefono ? sucursalModel.Telefono : ""} />
                    </div>
                </div>

                {/*SEGUNDA COLUMNA*/}
                <div className="col-12 col-md-6">
                    {/*PROYECTO */}
                    <div className="input-group mb-3">
                        <div className="input-group-prepend">
                            <span className="input-group-text font-weight-bold" id="basic-addon1">Almacen</span>
                        </div>
                        <Select
                            options={projectOptions}
                            value={projectOptions.find(opt => opt.value === sucursalModel.Project) || null}
                            onChange={this.ChangeProject}
                            placeholder="Escribe para buscar almacen"
                            isDisabled={action === 2 && !editMode}
                            isSearchable={true}
                            isClearable={true}
                            menuPortalTarget={document.body}
                            noOptionsMessage={() => 'No se encontraron coincidencias'}
                            styles={{
                                container: (base) => ({ ...base, flex: 1 }),
                                control: (base) => ({ ...base, height: 40, minHeight: 40, borderRadius: 4, backgroundColor: "transparent", borderColor: "#ced4da", borderTopLeftRadius: 0, borderBottomLeftRadius: 0 }),
                                menu: (base) => ({ ...base, zIndex: 9999 }),
                                menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                valueContainer: (base) => ({ ...base, padding: "0 8px" }),
                                input: (base) => ({ ...base, margin: 0, padding: 0, color: "#000" }),
                                singleValue: (base) => ({ ...base, color: "#000" })
                            }}
                        />
                    </div>
                    {/* FONTERA O O NO */}
                    <div className="input-group mb-3">
                        <div className="input-group-prepend">
                            <span className="input-group-text font-weight-bold" id="basic-addon1">Frontera</span>
                        </div>
                        <select
                            name="selectisBorder"
                            className="form-control"
                            id="selectisBorder"
                            disabled={(action === 2 && !editMode) ? true : false}
                            style={{ color: "#000", borderRadius: 4, backgroundColor: "transparent", height: 40 }}
                            value={sucursalModel.isBorder || ""}
                            onChange={this.ChangeisBorder}
                        >
                            <option value='---'>Seleccionar</option>
                            <option value='Y'>SI</option>
                            <option value='N'>NO</option>
                        </select>
                    </div>

                    {/* zona horaria */}
                    <div className="input-group mb-3">
                        <div className="input-group-prepend">
                            <span className="input-group-text font-weight-bold" id="basic-addon1">
                                <span className="d-none d-xl-inline">Zona horaria</span>
                                <span className="d-inline d-xl-none">Zona</span>
                            </span>
                        </div>
                        <select
                            name="selectisBorder"
                            className="form-control"
                            id="selectisBorder"
                            disabled={(action === 2 && !editMode) ? true : false}
                            style={{ color: "#000", borderRadius: 4, backgroundColor: "transparent", height: 40 }}
                            value={sucursalModel.TimeZone || ""}
                            onChange={this.ChangeTimeZone}
                        >
                            <option value='---'>Seleccionar</option>
                            <option value='-08'>Zona Noroeste UTC-8 </option>
                            <option value='-07'>Zona Pacífico UTC-7 </option>
                            <option value='-06'>Zona Centro UTC-6 </option>
                            <option value='-05'>Zona Sureste UTC-5 </option>

                        </select>

                    </div>

                    {/* Cuenta contable para Devoluciones */}
                    <div className="input-group mb-3">
                        <div className="input-group-prepend">
                            <label className="input-group-text font-weight-bold">
                                <span className="d-none d-xl-inline">Cuenta de Mayor para Devoluciones</span>
                                <span className="d-inline d-xl-none">Cta. Devoluciones</span>
                            </label>
                        </div>
                        <label className="form-control label-container">{!!sucursalModel.ActCodeRT && sucursalModel.ActCodeRT !== "" ? sucursalModel.ActCodeRT + " - " : ""}{sucursalModel.ActNameRT || ""}</label>
                        <div className="input-group-prepend">
                            <button
                                id="btn-CNAcctCode"
                                className="btn btn-outline-warning rounded-right btn-custom"
                                disabled={action === 2 && !editMode}
                                onClick={() => this.openActCodeCNandRTModal(1)}>
                                <i className="fa fa-list" />
                            </button>
                        </div>
                    </div>

                    {/* Cuenta contable para Cancelaciones */}
                    <div className="input-group mb-3">
                        <div className="input-group-prepend">
                            <label className="input-group-text font-weight-bold">
                                <span className="d-none d-xl-inline">Cuenta de Mayor para Cancelaciones</span>
                                <span className="d-inline d-xl-none">Cta. Cancelaciones</span>
                            </label>
                        </div>
                        <label className="form-control label-container">{!!sucursalModel.ActCodeCN && sucursalModel.ActCodeCN !== "" ? sucursalModel.ActCodeCN + " - " : ""}{sucursalModel.ActNameCN || ""}</label>
                        <div className="input-group-prepend">
                            <button
                                id="btn-CNAcctCode"
                                className="btn btn-outline-warning rounded-right btn-custom"
                                disabled={action === 2 && !editMode}
                                onClick={() => this.openActCodeCNandRTModal(0)}>
                                <i className="fa fa-list" />
                            </button>
                        </div>
                    </div>

                    {/* Tipo */}
                    <div className="input-group mb-3">
                        <div className="input-group-prepend">
                            <span className="input-group-text font-weight-bold" id="basic-addon1">
                                <span className="d-none d-xl-inline">Tipo Sucursal</span>
                                <span className="d-inline d-xl-none">Tipo</span>
                            </span>
                        </div>
                        <select
                            name="selectisBorder"
                            className="form-control"
                            id="selectisBorder"
                            disabled={(action === 2 && !editMode) ? true : false}
                            style={{ color: "#000", borderRadius: 4, backgroundColor: "transparent", height: 40 }}
                            value={sucursalModel.Type || ""}
                            onChange={this.ChangeType}
                        >
                            <option value=''>Seleccionar</option>
                            <option value='1'>Zonal</option>
                            <option value='2'>Planta</option>
                            <option value='3'>Maestra</option>

                        </select>

                    </div>
                </div>
            </div>
        )
    };

    renderSucursalBody = () => {
        const {
            action,
            editMode,
            sucursalModel,
            OpenPartnerModal,
            ShowWhsModal,
            priceList,
            OpenSeriesModal,
            DeletePayMethod,
            UpgradeDocumentLoop,
            SetInitialConsecutiveInfo,
            SearchedConsecutiveInfo,
            SetInitialSeries,
            documentTypeSeries
        } = this.props;
        const middleConsecutiveArray = sucursalModel.ConsecutiveDocs && (sucursalModel.ConsecutiveDocs.length / 2);

        return (
            <div style={{ marginTop: 30 }}>
                <nav>
                    <div className="nav nav-tabs" id="nav-tab" role="tablist">
                        {/* CLIENTES */}
                        <a
                            className="nav-item nav-link font-weight-bold text-secondary active"
                            id="nav-profile-tab-Clientes"
                            data-toggle="tab"
                            href="#DatosMaestrosClientes"
                            aria-controls="DatosMaestrosClientes">
                            Clientes
                        </a>
                        {/* <a
                            className="nav-item nav-link font-weight-bold text-secondary"
                            id="nav-profile-tab-Finanzas"
                            data-toggle="tab"
                            href="#DatosMaestrosFinanzas"
                            aria-controls="DatosMaestrosFinanzas">
                            Finanzas
                        </a> */}
                        {/* SERIES DOCS */}
                        <a
                            className="nav-item nav-link font-weight-bold text-secondary"
                            id="nav-profile-tab-Documentos"
                            data-toggle="tab"
                            href="#DatosMaestrosDocumentos"
                            aria-controls="DatosMaestrosDocumentos">
                            Series Documentos
                        </a>
                        {/* ALMACENES */}
                        <a
                            className="nav-item nav-link font-weight-bold text-secondary"
                            id="nav-profile-tab-almacenes"
                            data-toggle="tab"
                            href="#almacenes"
                            aria-controls="almacenes">
                            Almacenes
                        </a>
                        {/* LISTAS DE PRECIOS  */}
                        <a
                            className="nav-item nav-link font-weight-bold text-secondary"
                            id="nav-profile-tab-listas"
                            data-toggle="tab"
                            href="#listas"
                            aria-controls="listas">
                            Listas de precios
                        </a>
                        {/* VENTAS */}
                        <a
                            className="nav-item nav-link font-weight-bold text-secondary"
                            id="nav-profile-tab-ventas"
                            data-toggle="tab"
                            href="#ventas"
                            aria-controls="ventas">
                            Ventas
                        </a>
                        {/* METODOS DE PAGO */}
                        <a
                            className="nav-item nav-link font-weight-bold text-secondary"
                            id="nav-profile-tab-paymentMethods"
                            data-toggle="tab"
                            href="#paymentMethods"
                            aria-controls="paymentMethods">
                            Métodos de pago
                        </a>
                        {/* DOCUMENTOS CONSECUTIVOS */}
                        <a
                            className="nav-item nav-link font-weight-bold text-secondary"
                            id="nav-profile-tab-Documentos"
                            data-toggle="tab"
                            href="#documentosConsecutivos"
                            onClick={() => SetInitialConsecutiveInfo()}
                            aria-controls="documentosConsecutivos" >
                            Documentos Consecutivos
                        </a>
                        {/* SERIES Y CORRELATIVOS */}
                        <a
                            className="nav-item nav-link font-weight-bold text-secondary"
                            id="nav-profile-tab-consecutives"
                            data-toggle="tab"
                            href="#seriesAndConsecutives"
                            aria-controls="seriesAndConsecutives"
                            onClick={() => SetInitialSeries()}
                        >
                            Correlativos PLANTA
                        </a>
                        {/* SERIES Y CORRELATIVOS */}
                        <a
                            className="nav-item nav-link font-weight-bold text-secondary"
                            id="nav-profile-tab-consecutivesPUERTA"
                            data-toggle="tab"
                            href="#seriesAndconsecutivesPUERTA"
                            aria-controls="seriesAndconsecutivesPUERTA"
                            onClick={() => SetInitialSeries()}
                        >
                            Correlativos PUERTA
                        </a>
                    </div>
                </nav>
                <div className="tab-content border border-top-0 rounded-bottom p-2" style={{ textAlign: 'left' }}>
                    {/* CLIENTES */}
                    <div className=" tab-pane active" id="DatosMaestrosClientes" aria-labelledby="nav-profile-tab-Clientes">
                        <div className="row">
                            <div className="col-12 col-md-4 mb-3">
                                {/*CLIENTES DE LA SUCURSAL*/}
                                <div className="input-group">
                                    <div className="input-group-prepend">
                                        <span className="input-group-text font-weight-bold" id="basic-addon1">Clientes</span>
                                    </div>
                                    <input type="text" className="form-control"
                                        style={{ backgroundColor: 'transparent', borderColor: '#ced4da', color: '#000' }}
                                        id="Sucur_Clientes"
                                        disabled={true}
                                        value={sucursalModel.Clientes ? sucursalModel.Clientes : ""} />
                                    <button
                                        type="button"
                                        style={{ backgroundColor: 'transparent', color: '#EABF28' }}
                                        className="input-group-text"
                                        disabled={(action === 2 && !editMode) ? true : false}
                                        onClick={OpenPartnerModal}>
                                        <i className="fa fa-search" aria-hidden="true" />
                                    </button>
                                </div>
                            </div>
                            <div className="col-12 col-md-8"></div>
                        </div>

                        <div className="row">
                            <div className="col-12">
                                <div className="w-100 table-scroll tab-pane fade show active" aria-labelledby="nav-home-tab-Contenido" style={{ marginBottom: 0, minHeight: 400, maxHeight: 500 }}>
                                    <table className="table response" style={{ marginBottom: 0 }}>
                                    <thead>
                                        <tr>
                                            <th className="sticky-header table-header-yellow" style={{ textAlign: "center" }}>#</th>
                                            <th className="sticky-header table-header-yellow" style={{ textAlign: "center" }}>Default</th>
                                            <th className="sticky-header table-header-yellow" style={{ textAlign: "center" }}>Código</th>
                                            <th className="sticky-header table-header-yellow" style={{ textAlign: "center" }}>Nombre</th>
                                            <th className="sticky-header table-header-yellow"
                                                style={{ width: 50, textAlign: "center" }}>
                                            </th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                        {!!sucursalModel.ListPartners && sucursalModel.ListPartners.map((partner, index) => {
                                            return (
                                                <tr key={index}>
                                                    <td style={{ textAlign: "center" }}>{index + 1}</td>
                                                    <td style={{ textAlign: "center" }}>
                                                        <input
                                                            type="radio"
                                                            name="optradio"
                                                            disabled={(action === 2 && !editMode) ? true : false}
                                                            checked={sucursalModel.Clientes === partner.CardCode ? true : false}
                                                            id="radio"
                                                            onChange={() => this.ChangeClientes(partner.CardCode)}
                                                            style={{ marginRight: '5px' }}
                                                        />
                                                    </td>
                                                    <td style={{ textAlign: "center" }}>{partner.CardCode}</td>
                                                    <td>{partner.CardName}</td>
                                                    <td className="sticky-column">
                                                        <button
                                                            type="button"
                                                            style={{
                                                                backgroundColor: 'transparent',
                                                                padding: 5,
                                                                color: '#c42222',
                                                                paddingTop: 2,
                                                                paddingBottom: 2,
                                                            }}
                                                            className="btn"
                                                            disabled={(action === 2 && !editMode) ? true : false}
                                                            onClick={() => this.Delete(index)}>
                                                            <i className="fas fa-trash-alt" aria-hidden="true" size="10" />
                                                        </button>
                                                    </td>
                                                </tr>
                                            )
                                        })}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* FINANZAS */}
                    <div className="container tab-pane"
                        id="DatosMaestrosFinanzas"
                        aria-labelledby="nav-profile-tab-Finanzas"
                    >
                        <div className="row col-sm col" style={{ paddingRight: 0 }}>
                            <div className="col-12">
                                <div className="w-100 table-scroll tab-pane fade show " aria-labelledby="nav-home-tab-Contenido" style={{ marginBottom: 0, minheight: 400, maxHeight: 500 }}>

                                </div>
                            </div>
                        </div>
                    </div>
                    {/* SERIES DE DOCUMENTOS */}
                    <div className="tab-pane" id="DatosMaestrosDocumentos" aria-labelledby="nav-profile-tab-Documentos">
                        <div className="row">
                            {/*PRIMER COLUMNA*/}
                            <div className="col-12 col-md-6 col-xl-4">
                                {/*SERIES OFERTA DE VENTA*/}
                                <div className="input-group mb-3">
                                    <div className="input-group-prepend">
                                        <span className="input-group-text font-weight-bold" id="basic-addon1">
                                            <span className="d-none d-xl-inline">Oferta de venta</span>
                                            <span className="d-inline d-xl-none">Oferta Venta</span>
                                        </span>
                                    </div>
                                    <input type="text" className="form-control input-sm"
                                        id="txtGroupCode"
                                        disabled={true}
                                        value={sucursalModel.U_FMB_ValidateSeriesOQUT ? sucursalModel.U_FMB_ValidateSeriesOQUT : ""}
                                    />

                                    <button
                                        type="button"
                                        style={{ backgroundColor: 'transparent', color: '#EABF28' }}
                                        className="input-group-text"
                                        onClick={() => OpenSeriesModal('quotations', sucursalModel.U_FMB_ValidateSeriesOQUT)}
                                    >
                                        <i className="fa fa-list" aria-hidden="true" />
                                    </button>
                                </div>

                                {/*SERIES ORDEN DE VENTA*/}
                                <div className="input-group mb-3">
                                    <div className="input-group-prepend">
                                        <span className="input-group-text font-weight-bold" id="basic-addon1">
                                            <span className="d-none d-xl-inline">Orden de venta</span>
                                            <span className="d-inline d-xl-none">Orden Venta</span>
                                        </span>
                                    </div>
                                    <input type="text" className="form-control input-sm"
                                        id="txtGroupCode"
                                        disabled={true}
                                        value={sucursalModel.U_FMB_ValidateSeriesORDR ? sucursalModel.U_FMB_ValidateSeriesORDR : ""}
                                    />

                                    <button
                                        type="button"
                                        style={{ backgroundColor: 'transparent', color: '#EABF28' }}
                                        className="input-group-text"
                                        onClick={() => OpenSeriesModal('orderSales', sucursalModel.U_FMB_ValidateSeriesORDR)}
                                    >
                                        <i className="fa fa-list" aria-hidden="true" />
                                    </button>

                                </div>

                                {/*SERIES ENTREGAS*/}
                                <div className="input-group mb-3">
                                    <div className="input-group-prepend">
                                        <span className="input-group-text font-weight-bold" id="basic-addon1">
                                            <span className="d-none d-xl-inline">Entregas</span>
                                            <span className="d-inline d-xl-none">Entregas</span>
                                        </span>
                                    </div>
                                    <input type="text" className="form-control input-sm"
                                        id="txtGroupCode"
                                        disabled={true}
                                        value={sucursalModel.U_FMB_ValidateSeriesODLN ? sucursalModel.U_FMB_ValidateSeriesODLN : ""}
                                    />
                                    <button
                                        type="button"
                                        style={{ backgroundColor: 'transparent', color: '#EABF28' }}
                                        className="input-group-text"
                                        onClick={() => OpenSeriesModal('deliveries', sucursalModel.U_FMB_ValidateSeriesODLN)}
                                    >
                                        <i className="fa fa-list" aria-hidden="true" />
                                    </button>

                                </div>

                                {/*SERIES FACTURAS*/}
                                <div className="input-group mb-3">
                                    <div className="input-group-prepend">
                                        <span className="input-group-text font-weight-bold" id="basic-addon1">
                                            <span className="d-none d-xl-inline">Facturas</span>
                                            <span className="d-inline d-xl-none">Facturas</span>
                                        </span>
                                    </div>
                                    <input type="text" className="form-control input-sm"
                                        id="txtGroupCode"
                                        disabled={true}
                                        value={sucursalModel.U_FMB_ValidateSeriesOINV ? sucursalModel.U_FMB_ValidateSeriesOINV : ""}
                                    />

                                    <button
                                        type="button"
                                        style={{ backgroundColor: 'transparent', color: '#EABF28' }}
                                        className="input-group-text"
                                        onClick={() => OpenSeriesModal('invoice', sucursalModel.U_FMB_ValidateSeriesOINV)}
                                    >
                                        <i className="fa fa-list" aria-hidden="true" />
                                    </button>

                                </div>

                                {/*SERIES DEVOLUCIONES*/}
                                <div className="input-group mb-3">
                                    <div className="input-group-prepend">
                                        <span className="input-group-text font-weight-bold" id="basic-addon1">
                                            <span className="d-none d-xl-inline">Devoluciones</span>
                                            <span className="d-inline d-xl-none">Devoluciones</span>
                                        </span>
                                    </div>
                                    <input type="text" className="form-control input-sm"
                                        id="txtGroupCode"
                                        disabled={true}
                                        value={sucursalModel.U_FMB_ValidateSeriesORDN ? sucursalModel.U_FMB_ValidateSeriesORDN : ""}
                                    />

                                    <button
                                        type="button"
                                        style={{ backgroundColor: 'transparent', color: '#EABF28' }}
                                        className="input-group-text"
                                        onClick={() => OpenSeriesModal('return', sucursalModel.U_FMB_ValidateSeriesORDN)}
                                    >
                                        <i className="fa fa-list" aria-hidden="true" />
                                    </button>

                                </div>

                                {/*SERIES NOTA DE DÉBITO*/}
                                <div className="input-group mb-3">
                                    <div className="input-group-prepend">
                                        <span className="input-group-text font-weight-bold" id="basic-addon1">
                                            <span className="d-none d-xl-inline">Nota de débito</span>
                                            <span className="d-inline d-xl-none">N Débito</span>
                                        </span>
                                    </div>
                                    <input type="text" className="form-control input-sm"
                                        id="txtGroupCode"
                                        disabled={true}
                                        value={sucursalModel.U_FMB_ValidateSeriesDN ? sucursalModel.U_FMB_ValidateSeriesDN : ""}
                                    />

                                    <button
                                        type="button"
                                        style={{ backgroundColor: 'transparent', color: '#EABF28' }}
                                        className="input-group-text"
                                        onClick={() => OpenSeriesModal('debitNote', sucursalModel.U_FMB_ValidateSeriesDN)}
                                    >
                                        <i className="fa fa-list" aria-hidden="true" />
                                    </button>
                                </div>

                                {/*SERIES NOTA DE CRÉDITO*/}
                                <div className="input-group mb-3">
                                    <div className="input-group-prepend">
                                        <span className="input-group-text font-weight-bold" id="basic-addon1">
                                            <span className="d-none d-xl-inline">Nota de crédito</span>
                                            <span className="d-inline d-xl-none">N Crédito</span>
                                        </span>
                                    </div>
                                    <input type="text" className="form-control input-sm"
                                        id="txtGroupCode"
                                        disabled={true}
                                        value={sucursalModel.U_FMB_ValidateSeriesORIN ? sucursalModel.U_FMB_ValidateSeriesORIN : ""}
                                    />

                                    <button
                                        type="button"
                                        style={{ backgroundColor: 'transparent', color: '#EABF28' }}
                                        className="input-group-text"
                                        onClick={() => OpenSeriesModal('creditNote', sucursalModel.U_FMB_ValidateSeriesORIN)}
                                    >
                                        <i className="fa fa-list" aria-hidden="true" />
                                    </button>

                                </div>

                                {/*SERIES OFERTA DE COMPRA*/}
                                <div className="input-group mb-3">
                                    <div className="input-group-prepend">
                                        <span className="input-group-text font-weight-bold" id="basic-addon1">
                                            <span className="d-none d-xl-inline">Oferta de compra</span>
                                            <span className="d-inline d-xl-none">Oferta Compra</span>
                                        </span>
                                    </div>
                                    <input type="text" className="form-control input-sm"
                                        id="txtGroupCode"
                                        disabled={true}
                                        value={sucursalModel.U_FMB_ValidateSeriesOPQT ? sucursalModel.U_FMB_ValidateSeriesOPQT : ""}
                                    />

                                    <button
                                        type="button"
                                        style={{ backgroundColor: 'transparent', color: '#EABF28' }}
                                        className="input-group-text"
                                        onClick={() => OpenSeriesModal('PurchaseQuotation', sucursalModel.U_FMB_ValidateSeriesOPQT)}
                                    >
                                        <i className="fa fa-list" aria-hidden="true" />
                                    </button>

                                </div>

                                {/*SERIES ORDEN DE COMPRA*/}
                                <div className="input-group mb-3">
                                    <div className="input-group-prepend">
                                        <span className="input-group-text font-weight-bold" id="basic-addon1">
                                            <span className="d-none d-xl-inline">Orden de compra</span>
                                            <span className="d-inline d-xl-none">Orden Compra</span>
                                        </span>
                                    </div>
                                    <input type="text" className="form-control input-sm"
                                        id="txtGroupCode"
                                        disabled={true}
                                        value={sucursalModel.U_FMB_ValidateSeriesOPOR ? sucursalModel.U_FMB_ValidateSeriesOPOR : ""}
                                    />

                                    <button
                                        type="button"
                                        style={{ backgroundColor: 'transparent', color: '#EABF28' }}
                                        className="input-group-text"
                                        onClick={() => OpenSeriesModal('PurchaseOrder', sucursalModel.U_FMB_ValidateSeriesOPOR)}
                                    >
                                        <i className="fa fa-list" aria-hidden="true" />
                                    </button>

                                </div>

                                {/*SERIES ENTRADA DE MERCANCIA COMPRAS*/}
                                <div className="input-group mb-3">
                                    <div className="input-group-prepend">
                                        <span className="input-group-text font-weight-bold" id="basic-addon1">
                                            <span className="d-none d-xl-inline">Entrada mercancía compras</span>
                                            <span className="d-inline d-xl-none">Ent Merc Compra</span>
                                        </span>
                                    </div>
                                    <input type="text" className="form-control input-sm"
                                        id="txtGroupCode"
                                        disabled={true}
                                        value={sucursalModel.U_FMB_ValidateSeriesOPDN ? sucursalModel.U_FMB_ValidateSeriesOPDN : ""}
                                    />

                                    <button
                                        type="button"
                                        style={{ backgroundColor: 'transparent', color: '#EABF28' }}
                                        className="input-group-text"
                                        onClick={() => OpenSeriesModal('GoodsReceipt', sucursalModel.U_FMB_ValidateSeriesOPDN)}
                                    >
                                        <i className="fa fa-list" aria-hidden="true" />
                                    </button>

                                </div>

                                {/*SERIES DEVOLUCION MERCANCIA COMPRAS*/}
                                <div className="input-group mb-3">
                                    <div className="input-group-prepend">
                                        <span className="input-group-text font-weight-bold" id="basic-addon1">
                                            <span className="d-none d-xl-inline">Devolución mercancía compras</span>
                                            <span className="d-inline d-xl-none">Dev Merc Compra</span>
                                        </span>
                                    </div>
                                    <input type="text" className="form-control input-sm"
                                        id="txtGroupCode"
                                        disabled={true}
                                        value={sucursalModel.U_FMB_ValidateSeriesORPD ? sucursalModel.U_FMB_ValidateSeriesORPD : ""}
                                    />

                                    <button
                                        type="button"
                                        style={{ backgroundColor: 'transparent', color: '#EABF28' }}
                                        className="input-group-text"
                                        onClick={() => OpenSeriesModal('purchaseReturn', sucursalModel.U_FMB_ValidateSeriesORPD)}
                                    >
                                        <i className="fa fa-list" aria-hidden="true" />
                                    </button>

                                </div>
                            </div>

                            {/*SEGUNDA COLUMNA*/}
                            <div className="col-12 col-md-6 col-xl-4">
                                {/*SERIES FACTURA DE PROVEEDOR*/}
                                <div className="input-group mb-3">
                                    <div className="input-group-prepend">
                                        <span className="input-group-text font-weight-bold" id="basic-addon1">
                                            <span className="d-none d-xl-inline">Factura proveedor</span>
                                            <span className="d-inline d-xl-none">Factura Proveedor</span>
                                        </span>
                                    </div>
                                    <input type="text" className="form-control input-sm"
                                        id="txtGroupCode"
                                        disabled={true}
                                        value={sucursalModel.U_FMB_ValidateSeriesOPCH ? sucursalModel.U_FMB_ValidateSeriesOPCH : ""}
                                    />

                                    <button
                                        type="button"
                                        style={{ backgroundColor: 'transparent', color: '#EABF28' }}
                                        className="input-group-text"
                                        onClick={() => OpenSeriesModal('purchaseInvoice', sucursalModel.U_FMB_ValidateSeriesOPCH)}
                                    >
                                        <i className="fa fa-list" aria-hidden="true" />
                                    </button>

                                </div>

                                {/*ORDENES DE PRODUCCIÓN*/}
                                <div className="input-group mb-3">
                                    <div className="input-group-prepend">
                                        <span className="input-group-text font-weight-bold" id="basic-addon1">
                                            <span className="d-none d-xl-inline">Orden de producción</span>
                                            <span className="d-inline d-xl-none">Orden Produc</span>
                                        </span>
                                    </div>
                                    <input type="text" className="form-control input-sm"
                                        id="txtSeries"
                                        disabled={true}
                                        value={sucursalModel.U_FMB_ValidateSeriesOWOR ? sucursalModel.U_FMB_ValidateSeriesOWOR : ""}
                                    />
                                    <button
                                        type="button"
                                        style={{ backgroundColor: 'transparent', color: '#EABF28' }}
                                        className="input-group-text"
                                        onClick={() => OpenSeriesModal('ProductionOrder', sucursalModel.U_FMB_ValidateSeriesOWOR)}
                                    >
                                        <i className="fa fa-list" aria-hidden="true" />
                                    </button>

                                </div>

                                {/*SERIES NOTA DE CRÉDITO PROVEEDOR*/}
                                <div className="input-group mb-3">
                                    <div className="input-group-prepend">
                                        <span className="input-group-text font-weight-bold" id="basic-addon1">
                                            <span className="d-none d-xl-inline">Nota de crédito proveedor</span>
                                            <span className="d-inline d-xl-none">N Créd Prov</span>
                                        </span>
                                    </div>
                                    <input type="text" className="form-control input-sm"
                                        id="txtGroupCode"
                                        disabled={true}
                                        value={sucursalModel.U_FMB_ValidateSeriesORPC ? sucursalModel.U_FMB_ValidateSeriesORPC : ""}
                                    />

                                    <button
                                        type="button"
                                        style={{ backgroundColor: 'transparent', color: '#EABF28' }}
                                        className="input-group-text"
                                        onClick={() => OpenSeriesModal('purchaseCreditNotes', sucursalModel.U_FMB_ValidateSeriesORPC)}
                                    >
                                        <i className="fa fa-list" aria-hidden="true" />
                                    </button>

                                </div>
                                {/*SERIES NOTA DE DÉBITO PROVEEDOR*/}
                                <div className="input-group mb-3">
                                    <div className="input-group-prepend">
                                        <span className="input-group-text font-weight-bold" id="basic-addon1">
                                            <span className="d-none d-xl-inline">Nota de débito proveedor</span>
                                            <span className="d-inline d-xl-none">N Déb Prov</span>
                                        </span>
                                    </div>
                                    <input type="text" className="form-control input-sm"
                                        id="txtGroupCode"
                                        disabled={true}
                                        value={sucursalModel.U_FMB_ValidateSeriesDM ? sucursalModel.U_FMB_ValidateSeriesDM : ""}
                                    />
                                    <button
                                        type="button"
                                        style={{ backgroundColor: 'transparent', color: '#EABF28' }}
                                        className="input-group-text"
                                        onClick={() => OpenSeriesModal('purchaseDebitNotes', sucursalModel.U_FMB_ValidateSeriesDM)}
                                    >
                                        <i className="fa fa-list" aria-hidden="true" />
                                    </button>
                                </div>
                                {/* FACTURAS DE ANTICIPO DE PROVEEDOR */}
                                <div className="input-group mb-3">
                                    <div className="input-group-prepend">
                                        <span className="input-group-text font-weight-bold" id="basic-addon1">
                                            <span className="d-none d-xl-inline">Facturas de anticipo proveedor</span>
                                            <span className="d-inline d-xl-none">Anticipo Prov</span>
                                        </span>
                                    </div>
                                    <input type="text" className="form-control input-sm"
                                        id="txtGroupCode"
                                        disabled={true}
                                        value={sucursalModel.U_FMB_ValidateSeriesODPO ? sucursalModel.U_FMB_ValidateSeriesODPO : ""}
                                    />

                                    <button
                                        type="button"
                                        style={{ backgroundColor: 'transparent', color: '#EABF28' }}
                                        className="input-group-text"
                                        onClick={() => OpenSeriesModal('PurchaseDownPayments', sucursalModel.U_FMB_ValidateSeriesODPO)}
                                    >
                                        <i className="fa fa-list" aria-hidden="true" />
                                    </button>

                                </div>

                                {/*SERIES PAGOS*/}
                                <div className="input-group mb-3">
                                    <div className="input-group-prepend">
                                        <span className="input-group-text font-weight-bold" id="basic-addon1">Pagos</span>
                                    </div>
                                    <input type="text" className="form-control input-sm"
                                        id="txtGroupCode"
                                        disabled={true}
                                        value={sucursalModel.U_FMB_ValidateSeriesORCT ? sucursalModel.U_FMB_ValidateSeriesORCT : ""}
                                    />

                                    <button
                                        type="button"
                                        style={{ backgroundColor: 'transparent', color: '#EABF28' }}
                                        className="input-group-text"
                                        onClick={() => OpenSeriesModal('payment', sucursalModel.U_FMB_ValidateSeriesORCT)}
                                    >
                                        <i className="fa fa-list" aria-hidden="true" />
                                    </button>

                                </div>

                                {/*SERIES PAGOS EFECTUADOS*/}
                                <div className="input-group mb-3">
                                    <div className="input-group-prepend">
                                        <span className="input-group-text font-weight-bold" id="basic-addon1">
                                            <span className="d-none d-xl-inline">Pagos efectuados</span>
                                            <span className="d-inline d-xl-none">Pagos Efectuados</span>
                                        </span>
                                    </div>
                                    <input type="text" className="form-control input-sm"
                                        id="txtGroupCode"
                                        disabled={true}
                                        value={sucursalModel.U_FMB_ValidateSeriesOVPM ? sucursalModel.U_FMB_ValidateSeriesOVPM : ""}
                                    />

                                    <button
                                        type="button"
                                        style={{ backgroundColor: 'transparent', color: '#EABF28' }}
                                        className="input-group-text"
                                        onClick={() => OpenSeriesModal('outgoingPayment', sucursalModel.U_FMB_ValidateSeriesOVPM)}
                                    >
                                        <i className="fa fa-list" aria-hidden="true" />
                                    </button>

                                </div>

                                {/*SERIES TRASLADOS*/}
                                <div className="input-group mb-3">
                                    <div className="input-group-prepend">
                                        <span className="input-group-text font-weight-bold" id="basic-addon1">Traslados</span>
                                    </div>
                                    <input type="text" className="form-control input-sm"
                                        id="txtGroupCode"
                                        disabled={true}
                                        value={sucursalModel.U_FMB_ValidateSeriesOWTR ? sucursalModel.U_FMB_ValidateSeriesOWTR : ""}
                                    />

                                    <button
                                        type="button"
                                        style={{ backgroundColor: 'transparent', color: '#EABF28' }}
                                        className="input-group-text"
                                        onClick={() => OpenSeriesModal('transfers', sucursalModel.U_FMB_ValidateSeriesOWTR)}
                                    >
                                        <i className="fa fa-list" aria-hidden="true" />
                                    </button>

                                </div>

                                {/*SERIES SOLICITUD DE TRANSFERENCIA*/}
                                <div className="input-group mb-3">
                                    <div className="input-group-prepend">
                                        <span className="input-group-text font-weight-bold" id="basic-addon1">
                                            <span className="d-none d-xl-inline">Solicitud transferencia</span>
                                            <span className="d-inline d-xl-none">Solicitud Transfe</span>
                                        </span>
                                    </div>
                                    <input type="text" className="form-control input-sm"
                                        id="txtGroupCode"
                                        disabled={true}
                                        value={sucursalModel.U_FMB_ValidateSeriesOWTQ ? sucursalModel.U_FMB_ValidateSeriesOWTQ : ""}
                                    />

                                    <button
                                        type="button"
                                        style={{ backgroundColor: 'transparent', color: '#EABF28' }}
                                        className="input-group-text"
                                        onClick={() => OpenSeriesModal('transfersRequest', sucursalModel.U_FMB_ValidateSeriesOWTQ)}
                                    >
                                        <i className="fa fa-list" aria-hidden="true" />
                                    </button>

                                </div>

                                {/*SERIES ENTRADA DE MERCANCIA*/}
                                <div className="input-group mb-3">
                                    <div className="input-group-prepend">
                                        <span className="input-group-text font-weight-bold" id="basic-addon1">
                                            <span className="d-none d-xl-inline">Entrada de mercancía</span>
                                            <span className="d-inline d-xl-none">Entrada Mercancía</span>
                                        </span>
                                    </div>
                                    <input type="text" className="form-control input-sm"
                                        id="txtGroupCode"
                                        disabled={true}
                                        value={sucursalModel.U_FMB_ValidateSeriesOIGN ? sucursalModel.U_FMB_ValidateSeriesOIGN : ""}
                                    />

                                    <button
                                        type="button"
                                        style={{ backgroundColor: 'transparent', color: '#EABF28' }}
                                        className="input-group-text"
                                        onClick={() => OpenSeriesModal('transfersEntry', sucursalModel.U_FMB_ValidateSeriesOIGN)}
                                    >
                                        <i className="fa fa-list" aria-hidden="true" />
                                    </button>

                                </div>

                                {/*SERIES SALIDA DE MERCANCIA*/}
                                <div className="input-group mb-3">
                                    <div className="input-group-prepend">
                                        <span className="input-group-text font-weight-bold" id="basic-addon1">
                                            <span className="d-none d-xl-inline">Salida de mercancía</span>
                                            <span className="d-inline d-xl-none">Salida Mercancía</span>
                                        </span>
                                    </div>
                                    <input type="text" className="form-control input-sm"
                                        id="txtGroupCode"
                                        disabled={true}
                                        value={sucursalModel.U_FMB_ValidateSeriesOIGE ? sucursalModel.U_FMB_ValidateSeriesOIGE : ""}
                                    />

                                    <button
                                        type="button"
                                        style={{ backgroundColor: 'transparent', color: '#EABF28' }}
                                        className="input-group-text"
                                        onClick={() => OpenSeriesModal('transfersOutput', sucursalModel.U_FMB_ValidateSeriesOIGE)}
                                    >
                                        <i className="fa fa-list" aria-hidden="true" />
                                    </button>

                                </div>
                            </div>

                            {/* TERCERA COLUMNA */}
                            <div className="col-12 col-md-6 col-xl-4">
                                {/*SERIES SOLICITUD DE COMPRA*/}
                                <div className="input-group mb-3">
                                    <div className="input-group-prepend">
                                        <span className="input-group-text font-weight-bold" id="basic-addon1">
                                            <span className="d-none d-xl-inline">Solicitud de compra</span>
                                            <span className="d-inline d-xl-none">Solicitud Compra</span>
                                        </span>
                                    </div>
                                    <input type="text" className="form-control input-sm"
                                        id="txtGroupCode"
                                        disabled={true}
                                        value={sucursalModel.U_FMB_ValidateSeriesOPRQ ? sucursalModel.U_FMB_ValidateSeriesOPRQ : ""}
                                    />

                                    <button
                                        type="button"
                                        style={{ backgroundColor: 'transparent', color: '#EABF28' }}
                                        className="input-group-text"
                                        onClick={() => OpenSeriesModal('PurchaseRequest', sucursalModel.U_FMB_ValidateSeriesOPRQ)}
                                    >
                                        <i className="fa fa-list" aria-hidden="true" />
                                    </button>

                                </div>

                                {/*SERIES REVALORIZACION DE INVENTARIO*/}
                                <div className="input-group mb-3">
                                    <div className="input-group-prepend">
                                        <span className="input-group-text font-weight-bold" id="basic-addon1">
                                            <span className="d-none d-xl-inline">Revalorización Inventario</span>
                                            <span className="d-inline d-xl-none">Revalor Inv</span>
                                        </span>
                                    </div>
                                    <input type="text" className="form-control input-sm"
                                        id="txtGroupCode"
                                        disabled={true}
                                        value={sucursalModel.U_FMB_ValidateSeriesOMRV ? sucursalModel.U_FMB_ValidateSeriesOMRV : ""}
                                    />
                                    <button
                                        type="button"
                                        style={{ backgroundColor: 'transparent', color: '#EABF28' }}
                                        className="input-group-text"
                                        onClick={() => OpenSeriesModal('inventoryRevaluation', sucursalModel.U_FMB_ValidateSeriesOMRV)}
                                    >
                                        <i className="fa fa-list" aria-hidden="true" />
                                    </button>

                                </div>

                                {/*SERIES FACTURAS DE ANTICIPO */}
                                <div className="input-group mb-3">
                                    <div className="input-group-prepend">
                                        <span className="input-group-text font-weight-bold">
                                            <span className="d-none d-xl-inline">Facturas de anticipo</span>
                                            <span className="d-inline d-xl-none">Factura Anticipo</span>
                                        </span>
                                    </div>
                                    <input type="text" className="form-control input-sm"
                                        id="txtGroupCode"
                                        disabled={true}
                                        value={sucursalModel.U_FMB_ValidateSeriesODPI ? sucursalModel.U_FMB_ValidateSeriesODPI : ""}
                                    />
                                    <button
                                        type="button"
                                        style={{ backgroundColor: 'transparent', color: '#EABF28' }}
                                        className="input-group-text"
                                        onClick={() => OpenSeriesModal('DownPayments', sucursalModel.U_FMB_ValidateSeriesODPI)}
                                    >
                                        <i className="fa fa-list" aria-hidden="true" />
                                    </button>

                                </div>

                                {/*SERIES PRECIOS DE ENTREGA */}
                                <div className="input-group mb-3">
                                    <div className="input-group-prepend">
                                        <span className="input-group-text font-weight-bold">
                                            <span className="d-none d-xl-inline">Precios de entrega</span>
                                            <span className="d-inline d-xl-none">Precio Entrega</span>
                                        </span>
                                    </div>
                                    <input type="text" className="form-control input-sm"
                                        id="txtSeries"
                                        disabled={true}
                                        value={sucursalModel.U_FMB_ValidateSeriesOIPF ? sucursalModel.U_FMB_ValidateSeriesOIPF : ""}
                                    />
                                    <button
                                        type="button"
                                        style={{ backgroundColor: 'transparent', color: '#EABF28' }}
                                        className="input-group-text"
                                        onClick={() => OpenSeriesModal('LandedCosts', sucursalModel.U_FMB_ValidateSeriesOIPF)}
                                    >
                                        <i className="fa fa-list" aria-hidden="true" />
                                    </button>

                                </div>

                                {/* EMISION DE PROD */}
                                <div className="input-group mb-3">
                                    <div className="input-group-prepend">
                                        <span className="input-group-text font-weight-bold">
                                            <span className="d-none d-xl-inline">Emisión de producción</span>
                                            <span className="d-inline d-xl-none">Emisión Produc</span>
                                        </span>
                                    </div>
                                    <input type="text" className="form-control input-sm"
                                        id="txtSeries"
                                        disabled={true}
                                        value={sucursalModel.U_FMB_SeriesInventoryGenExits ? sucursalModel.U_FMB_SeriesInventoryGenExits : ""}
                                    />
                                    <button
                                        type="button"
                                        style={{ backgroundColor: 'transparent', color: '#EABF28' }}
                                        className="input-group-text"
                                        onClick={() => OpenSeriesModal('InventoryGenExits', sucursalModel.U_FMB_SeriesInventoryGenExits)}
                                    >
                                        <i className="fa fa-list" aria-hidden="true" />
                                    </button>
                                </div>

                                {/* RECIBO DE PROD */}
                                <div className="input-group mb-3">
                                    <div className="input-group-prepend">
                                        <span className="input-group-text font-weight-bold">
                                            <span className="d-none d-xl-inline">Recibo de producción</span>
                                            <span className="d-inline d-xl-none">Recibo Produc</span>
                                        </span>
                                    </div>
                                    <input type="text" className="form-control input-sm"
                                        id="txtSeries"
                                        disabled={true}
                                        value={sucursalModel.U_FMB_SeriesInventoryGenEntries ? sucursalModel.U_FMB_SeriesInventoryGenEntries : ""}
                                    />
                                    <button
                                        type="button"
                                        style={{ backgroundColor: 'transparent', color: '#EABF28' }}
                                        className="input-group-text"
                                        onClick={() => OpenSeriesModal('InventoryGenEntries', sucursalModel.U_FMB_SeriesInventoryGenEntries)}
                                    >
                                        <i className="fa fa-list" aria-hidden="true" />
                                    </button>

                                </div>

                                {/* SUGERIDO DE RESURTIDO */}
                                <div className="input-group mb-3">
                                    <div className="input-group-prepend">
                                        <span className="input-group-text font-weight-bold">
                                            <span className="d-none d-xl-inline">Sugerido de resurtido</span>
                                            <span className="d-inline d-xl-none">Suge Resurtido</span>
                                        </span>
                                    </div>
                                    <input type="text" className="form-control input-sm"
                                        id="txtSeries"
                                        disabled={true}
                                        value={sucursalModel.U_FMB_SeriesSugerido ? sucursalModel.U_FMB_SeriesSugerido : ""}
                                    />
                                    <button
                                        type="button"
                                        style={{ backgroundColor: 'transparent', color: '#EABF28' }}
                                        className="input-group-text"
                                        onClick={() => OpenSeriesModal('Sugerido', sucursalModel.U_FMB_SeriesSugerido)} >
                                        <i className="fa fa-list" aria-hidden="true" />
                                    </button>

                                </div>

                                {Modules.InventoryCounting &&
                                    <>
                                        {/* RECUENTO DE INVENTARIO */}
                                        <div className="input-group mb-3">
                                            <div className="input-group-prepend">
                                                <span className="input-group-text font-weight-bold">
                                                    <span className="d-none d-xl-inline">Recuento de Inventario</span>
                                                    <span className="d-inline d-xl-none">Recuento Inv</span>
                                                </span>
                                            </div>
                                            <input type="text" className="form-control input-sm"
                                                id="txtSeries"
                                                disabled={true}
                                                value={sucursalModel.U_FMB_ValidateSeriesOINC ? sucursalModel.U_FMB_ValidateSeriesOINC : ""} />
                                            <button
                                                type="button"
                                                style={{ backgroundColor: 'transparent', color: '#EABF28' }}
                                                className="input-group-text"
                                                onClick={() => OpenSeriesModal('InventoryCounting', sucursalModel.U_FMB_ValidateSeriesOINC)}
                                            >
                                                <i className="fa fa-list" aria-hidden="true" />
                                            </button>
                                        </div>

                                        {/* CONTABILIZACIÓN DE STOCK */}
                                        <div className="input-group mb-3">
                                            <div className="input-group-prepend">
                                            <span className="input-group-text font-weight-bold">
                                                <span className="d-none d-xl-inline">Contabilización de Stock</span>
                                                <span className="d-inline d-xl-none">Contab Stock</span>
                                            </span>
                                            </div>
                                            <input type="text" className="form-control input-sm"
                                                id="txtSeries"
                                                disabled={true}
                                                value={sucursalModel.U_FMB_ValidateSeriesOIQR ? sucursalModel.U_FMB_ValidateSeriesOIQR : ""} />
                                            <button
                                                type="button"
                                                style={{ backgroundColor: 'transparent', color: '#EABF28' }}
                                                className="input-group-text"
                                                onClick={() => OpenSeriesModal('InventoryPosting', sucursalModel.U_FMB_ValidateSeriesOIQR)} >
                                                <i className="fa fa-list" aria-hidden="true" />
                                            </button>
                                        </div>
                                    </>
                                }

                                {/* OFERTA DE COMPRA */}
                                <div className="input-group mb-3">
                                    <div className="input-group-prepend">
                                        <span className="input-group-text font-weight-bold">
                                            <span className="d-none d-xl-inline">Oferta de compra</span>
                                            <span className="d-inline d-xl-none">Oferta Compra</span>
                                        </span>
                                    </div>
                                    <input type="text" className="form-control input-sm"
                                        id="txtSeries"
                                        disabled={true}
                                        value={sucursalModel.U_FMB_ValidateSeriesOPQT ? sucursalModel.U_FMB_ValidateSeriesOPQT : ""}
                                    />
                                    <button
                                        type="button"
                                        style={{ backgroundColor: 'transparent', color: '#EABF28' }}
                                        className="input-group-text"
                                        onClick={() => OpenSeriesModal('purchaseQuotation', sucursalModel.U_FMB_ValidateSeriesOPQT)} >
                                        <i className="fa fa-list" aria-hidden="true" />
                                    </button>
                                </div>

                            </div>
                        </div>
                    </div>
                    {/* AlMACENES */}
                    <div className="tab-pane" id="almacenes" aria-labelledby="nav-profile-tab-Almacenes">
                        {/*ALMACENES DE LA SUCURSAL*/}
                        <div className="row g-3 mb-3">
                            <div className="col-12 col-md-4">
                                <div className="input-group">
                                    <div className="input-group-prepend">
                                        <span className="input-group-text font-weight-bold" id="basic-addon1">Almacenes</span>
                                    </div>
                                    <input type="text" className="form-control"
                                        style={{ backgroundColor: 'transparent', borderColor: '#ced4da', color: '#000' }}
                                        id="Sucur_Clientes"
                                        disabled={true}
                                    // value={sucursalModel.Clientes ? sucursalModel.Clientes : ""}
                                    />
                                    <button
                                        type="button"
                                        style={{ backgroundColor: 'transparent', color: '#EABF28' }}
                                        className="input-group-text"
                                        disabled={(action === 2 && !editMode) ? true : false}
                                        onClick={() => ShowWhsModal(true)}>
                                        <i className="fa fa-search" aria-hidden="true" />
                                    </button>
                                </div>
                            </div>
                            <div className="col-12 col-md-8"></div>
                        </div>
                        <div className="row">
                            <div className="col-12">
                                <div className="table-responsive" style={{ maxHeight: 500 }}>
                                    <table className="table" style={{ marginBottom: 0 }}>
                                    <thead>
                                        <tr>
                                            <th className="table-header-yellow" style={{ textAlign: "center" }}>#</th>
                                            <th className="table-header-yellow" style={{ textAlign: "center" }}>Código Almacén</th>
                                            <th className="table-header-yellow" style={{ textAlign: "center" }}>Nombre Almacén</th>
                                            <th className="table-header-yellow" style={{ textAlign: "center" }}></th>

                                        </tr>
                                    </thead>
                                        <tbody>
                                        {!!sucursalModel.ListWhs && sucursalModel.ListWhs.map((whs, index) => {
                                            return (
                                                <tr key={index}>
                                                    <td style={{ textAlign: "center", backgroundColor: "white" }}>{index + 1}</td>
                                                    <td style={{ textAlign: "center" }}>{whs.WhsCode}</td>
                                                    <td style={{ textAlign: "center" }}>{decodeText(whs.WhsName)}</td>
                                                    <td>
                                                        <button type="button"
                                                            style={{ backgroundColor: 'transparent', padding: 5, color: '#c42222', paddingTop: 2, paddingBottom: 2 }}
                                                            className="btn"
                                                            disabled={(action === 2 && !editMode) ? true : false}
                                                            onClick={() => this.DeleteWhsLine(index)}>
                                                            <i className="fas fa-trash-alt" aria-hidden="true" size="10" />
                                                        </button>
                                                    </td>
                                                </tr>
                                            )
                                        })}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* LISTAS DE PRECIOS */}
                    <div className="tab-pane" id="listas" aria-labelledby="nav-profile-tab-Listas">
                        <div className="row">

                            <div className="col-12 col-md-5 p-2">
                                <table className="table response" style={{ marginBottom: 0 }}>
                                <thead>
                                    <tr>
                                        <th colSpan={2}>Lista de precios por módulo</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    <tr>
                                        <td>Salida de mercancía:</td>
                                        <td>
                                            <select className="form-select form-control"
                                                value={sucursalModel.U_FMB_DEF_PLInventoryGenExitService}
                                                disabled={(action === 2 && !editMode) ? true : false}
                                                style={{ color: "#000", borderRadius: 4, backgroundColor: "transparent", height: 40 }}
                                                onChange={(event) => this.OnchangeOutMarch(event.target.value)}>
                                                <option value=''>Seleccione una opción</option>
                                                {!!priceList && priceList.map(price => {
                                                    return (
                                                        <option value={price.ListNum}>{price.ListName}</option>
                                                    )
                                                })}
                                            </select>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>Entrada de mercancía:</td>
                                        <td>
                                            <select className="form-select form-control"
                                                value={sucursalModel.U_FMB_DEF_PLInventoryGenEntryService}
                                                disabled={(action === 2 && !editMode) ? true : false}
                                                style={{ color: "#000", borderRadius: 4, backgroundColor: "transparent", height: 40 }}
                                                onChange={(event) => this.OnchangeEntryMarch(event.target.value)}>
                                                <option>Seleccione una opción</option>
                                                {!!priceList && priceList.map(price => {
                                                    return (
                                                        <option value={price.ListNum}>{price.ListName}</option>
                                                    )
                                                })}
                                            </select>
                                        </td>
                                    </tr>
                                    <tr>
                                        {/*  */}
                                        <td>Transferencia de Stock:</td>
                                        <td>
                                            <select className="form-select form-control"
                                                value={sucursalModel.U_FMB_DEF_PLStockTransfer}
                                                disabled={(action === 2 && !editMode) ? true : false}
                                                style={{ color: "#000", borderRadius: 4, backgroundColor: "transparent", height: 40 }}
                                                onChange={(event) => this.ChangePLStockTransfer(event.target.value)}>
                                                <option value=''>Seleccione una opción</option>
                                                {!!priceList && priceList.map(price => {
                                                    return (
                                                        <option value={price.ListNum}>{price.ListName}</option>
                                                    )
                                                })}
                                            </select>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <span className="d-none d-xl-inline">Solicitud de traslado de mercancía:</span>
                                            <span className="d-inline d-xl-none">Sol. traslado:</span>
                                        </td>
                                        <td>
                                            <select className="form-select form-control"
                                                value={sucursalModel.U_FMB_DEF_PLReqStockTransfer}
                                                disabled={(action === 2 && !editMode) ? true : false}
                                                style={{ color: "#000", borderRadius: 4, backgroundColor: "transparent", height: 40 }}
                                                onChange={(event) => this.ChangePLReqStockTransfer(event.target.value)}>
                                                <option value=''>Seleccione una opción</option>
                                                {!!priceList && priceList.map(price => {
                                                    return (
                                                        <option value={price.ListNum}>{price.ListName}</option>
                                                    )
                                                })}
                                            </select>
                                        </td>
                                    </tr>
                                    </tbody>
                                </table>
                            </div>
                            <div className="col-12 col-md-7 p-2">
                                <table className="table response" style={{ marginBottom: 0 }}>
                                <thead>
                                    <tr>
                                        <th colSpan={2}>&nbsp;</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>
                                            <span className="d-none d-xl-inline">Impresion de etiquetas:</span>
                                            <span className="d-inline d-xl-none">Imp. etiquetas:</span>
                                        </td>
                                        <td>
                                            <select className="form-select form-control"
                                                value={sucursalModel.U_FMB_PLPrintTags}
                                                disabled={(action === 2 && !editMode) ? true : false}
                                                style={{ color: "#000", borderRadius: 4, backgroundColor: "transparent", height: 40 }}
                                                onChange={(event) => this.ChangePLPrintTags(event.target.value)}>
                                                <option value=''>Seleccione una opción</option>
                                                {!!priceList && priceList.map(price => {
                                                    return (
                                                        <option value={price.ListNum}>{price.ListName}</option>
                                                    )
                                                })}
                                            </select>
                                        </td>
                                    </tr>
                                </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                    {/* VENTAS */}
                    <div className="tab-pane p-2" id="ventas" aria-labelledby="nav-profile-tab-Ventas">
                        {/* <div className="row" style={{paddingRight: 0}}> */}
                        <nav>
                            <div className="nav nav-tabs" id="nav-tab" role="tablist">
                                <a
                                    className="nav-item nav-link font-weight-bold text-secondary active"
                                    id="nav-profile-tab-Inventario"
                                    data-toggle="tab"
                                    href="#inventario"
                                    aria-controls="Inventario">
                                    Inventario
                                </a>
                                {/* <a
                                        className="nav-item nav-link font-weight-bold text-secondary"
                                        id="nav-profile-tab-Operaciones"
                                        data-toggle="tab"
                                        href="#operaciones"
                                        aria-controls="Operaciones">
                                        Operaciones
                                    </a>

                                    <a
                                        className="nav-item nav-link font-weight-bold text-secondary"
                                        id="nav-profile-tab-Generales"
                                        data-toggle="tab"
                                        href="#generales"
                                        aria-controls="Generales">
                                        Generales
                                    </a>
                                    <a
                                        className="nav-item nav-link font-weight-bold text-secondary"
                                        id="nav-profile-tab-Funcionalidades"
                                        data-toggle="tab"
                                        href="#funcionalidades"
                                        aria-controls="Funcionalidades">
                                        Funcionalidades
                                    </a>
                                    <a
                                        className="nav-item nav-link font-weight-bold text-secondary"
                                        id="nav-profile-tab-Otros"
                                        data-toggle="tab"
                                        href="#otros"
                                        aria-controls="Otros">
                                        Otros Modulos
                                    </a> */}


                            </div>
                        </nav>
                        <div className="tab-content border border-top-0 rounded-bottom p-2" style={{ textAlign: 'left' }}>
                            <div className="tab-pane active" id="inventario" aria-labelledby="nav-profile-tab-Clientes">
                                <div className='row'>
                                    <div className="col-12 col-md-6">

                                                <div className="input-group mb-3">
                                                    <div className="input-group-prepend">
                                                <span className="input-group-text font-weight-bold">
                                                    <span className="d-none d-xl-inline">Límite de partidas abiertas</span>
                                                    <span className="d-inline d-xl-none">Límite Partidas</span>
                                                </span>
                                                    </div>
                                                    <input type="text" className="form-control"
                                                        style={{ backgroundColor: 'transparent', borderColor: '#ced4da', color: '#000' }}
                                                        disabled={(action === 2 && !editMode) ? true : false}
                                                        onChange={(event) => this.ChangeLimitLines(event.target.value)}
                                                        value={sucursalModel.LimitLines || ""}
                                                    />
                                                </div>
                                            <div className="input-group mb-3">
                                            <div className="input-group-prepend">
                                                <span className="input-group-text font-weight-bold">
                                                    <span className="d-none d-xl-inline">Lista de precios mínimos</span>
                                                    <span className="d-inline d-xl-none">Precios Mínimos</span>
                                                </span>
                                                </div>
                                                    <select className="form-control"
                                                        value={sucursalModel.U_FMB_DEF_PLPriceMin}
                                                        disabled={(action === 2 && !editMode) ? true : false}
                                                        style={{ color: "#000", borderRadius: 4, backgroundColor: "transparent", height: 40 }}
                                                        onChange={(event) => this.ChangePLPriceMin(event.target.value)}>
                                                        <option value=''>Seleccione una opción</option>
                                                        {!!priceList && priceList.map(price => {
                                                            return (
                                                                <option value={price.ListNum}>{price.ListName}</option>
                                                            )
                                                        })}
                                                    </select>
                                                </div>
                                            <div className="input-group mb-3">
                                            <div className="input-group-prepend">
                                                 <span className="input-group-text font-weight-bold">
                                                    <span className="d-none d-xl-inline">Lista de precios base</span>
                                                    <span className="d-inline d-xl-none">Precios Base</span>
                                                </span>
                                                </div>
                                                    <select className="form-control"
                                                        value={sucursalModel.U_FMB_DEF_PLBasePrice}
                                                        disabled={(action === 2 && !editMode) ? true : false}
                                                        style={{ color: "#000", borderRadius: 4, backgroundColor: "transparent", height: 40 }}
                                                        onChange={(event) => this.ChangePLBasePrice(event.target.value)}>
                                                        <option value=''>Seleccione una opción</option>
                                                        {!!priceList && priceList.map(price => {
                                                            return (
                                                                <option value={price.ListNum}>{price.ListName}</option>
                                                            )
                                                        })}
                                                    </select>
                                    </div>

                                </div>
                                <div className="col-12 col-md-6 p-2">
                                    </div>
                                </div>
                            </div>
                            <div className="container tab-pane" id="operaciones" aria-labelledby="nav-profile-tab-Clientes">
                                <div className='row'>
                                    <div className="col-12 col-md-6 p-2">
                                        <table className="table response" style={{ marginBottom: 0 }}>
                                            <tr>
                                                <td >
                                                    <div className="form-check ">
                                                        <input className="form-check-input" type="checkbox" value="" id="flexCheckDefault" />
                                                        <label className="form-check-label" for="flexCheckDefault">
                                                            Default checkbox
                                                        </label>
                                                    </div>
                                                </td>
                                                <td>
                                                    <select className="form-select form-control" aria-label="Default select example">
                                                        <option selected>Open this select menu</option>
                                                        <option value="1">One</option>
                                                        <option value="2">Two</option>
                                                        <option value="3">Three</option>
                                                    </select>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td >
                                                    <div className="form-check ">
                                                        <input className="form-check-input" type="checkbox" value="" id="flexCheckDefault" />
                                                        <label className="form-check-label" for="flexCheckDefault">
                                                            Default checkbox
                                                        </label>
                                                    </div>
                                                </td>
                                                <td>
                                                    <select className="form-select form-control" aria-label="Default select example">
                                                        <option selected>Open this select menu</option>
                                                        <option value="1">One</option>
                                                        <option value="2">Two</option>
                                                        <option value="3">Three</option>
                                                    </select>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td >
                                                    <div className="form-check ">
                                                        <input className="form-check-input" type="checkbox" value="" id="flexCheckDefault" />
                                                        <label className="form-check-label" for="flexCheckDefault">
                                                            Default checkbox
                                                        </label>
                                                    </div>
                                                </td>
                                                <td>
                                                    <select className="form-select form-control" aria-label="Default select example">
                                                        <option selected>Open this select menu</option>
                                                        <option value="1">One</option>
                                                        <option value="2">Two</option>
                                                        <option value="3">Three</option>
                                                    </select>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td >
                                                    <div className="form-check ">
                                                        <input className="form-check-input" type="checkbox" value="" id="flexCheckDefault" />
                                                        <label className="form-check-label" for="flexCheckDefault">
                                                            Default checkbox
                                                        </label>
                                                    </div>
                                                </td>
                                                <td>
                                                    <select className="form-select form-control" aria-label="Default select example">
                                                        <option selected>Open this select menu</option>
                                                        <option value="1">One</option>
                                                        <option value="2">Two</option>
                                                        <option value="3">Three</option>
                                                    </select>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td >
                                                    <div className="form-check ">
                                                        <input className="form-check-input" type="checkbox" value="" id="flexCheckDefault" />
                                                        <label className="form-check-label" for="flexCheckDefault">
                                                            Default checkbox
                                                        </label>
                                                    </div>
                                                </td>
                                                <td>
                                                    <select className="form-select form-control" aria-label="Default select example">
                                                        <option selected>Open this select menu</option>
                                                        <option value="1">One</option>
                                                        <option value="2">Two</option>
                                                        <option value="3">Three</option>
                                                    </select>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td >
                                                    <div className="form-check ">
                                                        <input className="form-check-input" type="checkbox" value="" id="flexCheckDefault" />
                                                        <label className="form-check-label" for="flexCheckDefault">
                                                            Default checkbox
                                                        </label>
                                                    </div>
                                                </td>
                                                <td>
                                                    <select className="form-select form-control" aria-label="Default select example">
                                                        <option selected>Open this select menu</option>
                                                        <option value="1">One</option>
                                                        <option value="2">Two</option>
                                                        <option value="3">Three</option>
                                                    </select>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td >
                                                    <div className="form-check ">
                                                        <input className="form-check-input" type="checkbox" value="" id="flexCheckDefault" />
                                                        <label className="form-check-label" for="flexCheckDefault">
                                                            Default checkbox
                                                        </label>
                                                    </div>
                                                </td>
                                                <td>
                                                    <select className="form-select form-control" aria-label="Default select example">
                                                        <option selected>Open this select menu</option>
                                                        <option value="1">One</option>
                                                        <option value="2">Two</option>
                                                        <option value="3">Three</option>
                                                    </select>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td >
                                                    <div className="form-check ">
                                                        <input className="form-check-input" type="checkbox" value="" id="flexCheckDefault" />
                                                        <label className="form-check-label" for="flexCheckDefault">
                                                            Default checkbox
                                                        </label>
                                                    </div>
                                                </td>
                                                <td>
                                                    <select className="form-select form-control" aria-label="Default select example">
                                                        <option selected>Open this select menu</option>
                                                        <option value="1">One</option>
                                                        <option value="2">Two</option>
                                                        <option value="3">Three</option>
                                                    </select>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td >
                                                    <div className="form-check ">
                                                        <input className="form-check-input" type="checkbox" value="" id="flexCheckDefault" />
                                                        <label className="form-check-label" for="flexCheckDefault">
                                                            Default checkbox
                                                        </label>
                                                    </div>
                                                </td>
                                                <td>
                                                    <select className="form-select form-control" aria-label="Default select example">
                                                        <option selected>Open this select menu</option>
                                                        <option value="1">One</option>
                                                        <option value="2">Two</option>
                                                        <option value="3">Three</option>
                                                    </select>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td >
                                                    <div className="form-check ">
                                                        <input className="form-check-input" type="checkbox" value="" id="flexCheckDefault" />
                                                        <label className="form-check-label" for="flexCheckDefault">
                                                            Default checkbox
                                                        </label>
                                                    </div>
                                                </td>
                                                <td>
                                                    <select className="form-select form-control" aria-label="Default select example">
                                                        <option selected>Open this select menu</option>
                                                        <option value="1">One</option>
                                                        <option value="2">Two</option>
                                                        <option value="3">Three</option>
                                                    </select>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td >
                                                    <div className="form-check ">
                                                        <input className="form-check-input" type="checkbox" value="" id="flexCheckDefault" />
                                                        <label className="form-check-label" for="flexCheckDefault">
                                                            Default checkbox
                                                        </label>
                                                    </div>
                                                </td>
                                                <td>
                                                    <select className="form-select form-control" aria-label="Default select example">
                                                        <option selected>Open this select menu</option>
                                                        <option value="1">One</option>
                                                        <option value="2">Two</option>
                                                        <option value="3">Three</option>
                                                    </select>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td >
                                                    <div className="form-check ">
                                                        <input className="form-check-input" type="checkbox" value="" id="flexCheckDefault" />
                                                        <label className="form-check-label" for="flexCheckDefault">
                                                            Default checkbox
                                                        </label>
                                                    </div>
                                                </td>
                                                <td>
                                                    <select className="form-select form-control" aria-label="Default select example">
                                                        <option selected>Open this select menu</option>
                                                        <option value="1">One</option>
                                                        <option value="2">Two</option>
                                                        <option value="3">Three</option>
                                                    </select>
                                                </td>
                                            </tr>

                                        </table>
                                    </div>
                                    <div className="col-12 col-md-6 p-2">
                                        <table className="table response" style={{ marginBottom: 0 }}>
                                            <tr>
                                                <td >
                                                    <div className="form-check ">
                                                        <input className="form-check-input" type="checkbox" value="" id="flexCheckDefault" />
                                                        <label className="form-check-label" for="flexCheckDefault">
                                                            Default checkbox
                                                        </label>
                                                    </div>
                                                </td>
                                                <td>
                                                    <select className="form-select form-control" aria-label="Default select example">
                                                        <option selected>Open this select menu</option>
                                                        <option value="1">One</option>
                                                        <option value="2">Two</option>
                                                        <option value="3">Three</option>
                                                    </select>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td >
                                                    <div className="form-check ">
                                                        <input className="form-check-input" type="checkbox" value="" id="flexCheckDefault" />
                                                        <label className="form-check-label" for="flexCheckDefault">
                                                            Default checkbox
                                                        </label>
                                                    </div>
                                                </td>
                                                <td>
                                                    <select className="form-select form-control" aria-label="Default select example">
                                                        <option selected>Open this select menu</option>
                                                        <option value="1">One</option>
                                                        <option value="2">Two</option>
                                                        <option value="3">Three</option>
                                                    </select>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td >
                                                    <div className="form-check ">
                                                        <input className="form-check-input" type="checkbox" value="" id="flexCheckDefault" />
                                                        <label className="form-check-label" for="flexCheckDefault">
                                                            Default checkbox
                                                        </label>
                                                    </div>
                                                </td>
                                                <td>
                                                    <select className="form-select form-control" aria-label="Default select example">
                                                        <option selected>Open this select menu</option>
                                                        <option value="1">One</option>
                                                        <option value="2">Two</option>
                                                        <option value="3">Three</option>
                                                    </select>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td >
                                                    <div className="form-check ">
                                                        <input className="form-check-input" type="checkbox" value="" id="flexCheckDefault" />
                                                        <label className="form-check-label" for="flexCheckDefault">
                                                            Default checkbox
                                                        </label>
                                                    </div>
                                                </td>
                                                <td>
                                                    <select className="form-select form-control" aria-label="Default select example">
                                                        <option selected>Open this select menu</option>
                                                        <option value="1">One</option>
                                                        <option value="2">Two</option>
                                                        <option value="3">Three</option>
                                                    </select>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td >
                                                    <div className="form-check ">
                                                        <input className="form-check-input" type="checkbox" value="" id="flexCheckDefault" />
                                                        <label className="form-check-label" for="flexCheckDefault">
                                                            Default checkbox
                                                        </label>
                                                    </div>
                                                </td>
                                                <td>
                                                    <select className="form-select form-control" aria-label="Default select example">
                                                        <option selected>Open this select menu</option>
                                                        <option value="1">One</option>
                                                        <option value="2">Two</option>
                                                        <option value="3">Three</option>
                                                    </select>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td >
                                                    <div className="form-check ">
                                                        <input className="form-check-input" type="checkbox" value="" id="flexCheckDefault" />
                                                        <label className="form-check-label" for="flexCheckDefault">
                                                            Default checkbox
                                                        </label>
                                                    </div>
                                                </td>
                                                <td>
                                                    <select className="form-select form-control" aria-label="Default select example">
                                                        <option selected>Open this select menu</option>
                                                        <option value="1">One</option>
                                                        <option value="2">Two</option>
                                                        <option value="3">Three</option>
                                                    </select>
                                                </td>
                                            </tr>

                                        </table>
                                    </div>
                                </div>
                            </div>
                            <div className="container tab-pane" id="generales" aria-labelledby="nav-profile-tab-Clientes">

                            </div>
                            <div className="container tab-pane" id="funcionalidades" aria-labelledby="nav-profile-tab-Clientes">

                            </div>
                            <div className="container tab-pane" id="otros" aria-labelledby="nav-profile-tab-Clientes">

                            </div>
                        </div>


                    </div>
                    {/* METODOS DE PAGO BODY  */}
                    <div className="tab-pane" id="paymentMethods" aria-labelledby="nav-profile-tab-Listas">
                        <div className="row mb-3">
                            <div className="col-12 col-md-4">
                                <div className="input-group mb-3">
                                    <div className="input-group-prepend">
                                        <span className="input-group-text font-weight-bold" id="basic-addon1">
                                            <span className="d-none d-xl-inline">Agregar métodos de pago</span>
                                            <span className="d-inline d-xl-none">Agr.Método</span>
                                        </span>
                                    </div>
                                    <input type="text" className="form-control"
                                        style={{ backgroundColor: 'transparent', borderColor: '#ced4da', color: '#000' }}
                                        id="Sucur_Clientes"
                                        disabled={true}
                                    />
                                    <button
                                        type="button"
                                        style={{ backgroundColor: 'transparent', color: '#EABF28' }}
                                        className="input-group-text"
                                        disabled={(action === 2 && !editMode) ? true : false}
                                        onClick={() => this.ShowAddPayMethod(true)}
                                    >
                                        <i className="fa fa-search" aria-hidden="true" />
                                    </button>
                                </div>
                            </div>
                            <div className="col-12 col-md-8"></div>
                        </div>
                        <div className="row">
                            <div className="col-12">
                                <div className="table-responsive">
                                <table className="table response" style={{ marginBottom: 0 }}>
                                    <thead>
                                        <tr>
                                            <th scope="col">#</th>
                                            <th scope="col">
                                                <span className="d-none d-xl-inline">Método de pago código</span>
                                                <span className="d-inline d-xl-none">Código</span>
                                            </th>
                                            <th scope="col">
                                                <span className="d-none d-xl-inline">Método de pago nombre</span>
                                                <span className="d-inline d-xl-none">Nombre</span>
                                            </th>
                                            <th scope="col">
                                                <span className="d-none d-xl-inline">Código de cuenta de mayor</span>
                                                <span className="d-inline d-xl-none">Cta. mayor</span>
                                            </th>
                                            <th scope="col">
                                                <span className="d-none d-xl-inline">Nombre de cuenta de mayor</span>
                                                <span className="d-inline d-xl-none">Nombre cta.</span>
                                            </th>
                                                <th scope="col">
                                                    Uso
                                            </th>
                                            <th scope="col"></th>

                                        </tr>
                                    </thead>
                                    <tbody>
                                        {sucursalModel && Array.isArray(sucursalModel.ListPayMethods) &&
                                            sucursalModel.ListPayMethods.map((payMethod, index) => {

                                                return (
                                                    <tr key={index}>
                                                        <td>{index + 1}</td>
                                                        <td>{payMethod.codePayMethod ?? ''}</td>
                                                        <td>{payMethod.namePayMethod ?? ''}</td>
                                                        <td>{payMethod.AcctCode ?? ''}</td>
                                                        <td>{payMethod.AcctName ?? ''}</td>
                                                        <td>
                                                            <select className="form-control" value={payMethod.TipoUso ?? ''}
                                                                disabled={(action === 2 && !editMode) ? true : false}
                                                                onChange={(event) => this.ChangeTipoUsoPayMethod(index, event.target.value)}>
                                                                <option value="">Seleccionar</option>
                                                                <option value="1">Apps</option>
                                                                <option value="2">Branch</option>
                                                                <option value="3">Ambos</option>
                                                            </select>
                                                        </td>
                                                        <td style={{ background: "white", color: "#dc3545" }}>
                                                            <button
                                                                type="button"
                                                                className="btn btn-outline-danger"
                                                                onClick={() => DeletePayMethod(index)}
                                                                disabled={(action === 2 && !editMode) ? true : false}
                                                            >
                                                                <i className="fa fa-trash-o " />
                                                            </button>

                                                        </td>
                                                    </tr>
                                                )
                                            })}

                                    </tbody>

                                </table>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/*DOCUMENTOS CONSECUTIVOS */}
                    <div className="container tab-pane" id="documentosConsecutivos" aria-labelledby="nav-profile-tab-Documentos">
                        <div className="row">
                            {/*PRIMER COLUMNA*/}
                            <div className="col-12 col-md-6">
                                {(Number(action) === 2 && SearchedConsecutiveInfo) && sucursalModel.ConsecutiveDocs.slice(0, middleConsecutiveArray).map((elementDoc) => (
                                    <>
                                        <tr>
                                            <th colSpan={2}>{elementDoc.ThTitle}</th>
                                        </tr>
                                        <div className="input-group mb-3">
                                            <button
                                                type="button"
                                                style={{ backgroundColor: 'transparent', color: '#EABF28' }}
                                                className="input-group-text"
                                                onClick={() => UpgradeDocumentLoop(elementDoc)} >
                                                <i className="fa fa-arrow-up" aria-hidden="true" />
                                            </button>
                                            <div className="input-group-prepend">
                                                <span className="input-group-text font-weight-bold" id="basic-addon1">Loop</span>
                                            </div>
                                            <input type="text" className="form-control input-sm font-weight-bold" id="txtGroupCode" disabled={true}
                                                value={elementDoc.TypeDocLoop}
                                            />
                                            <div className="input-group-prepend">
                                                <span className="input-group-text font-weight-bold" id="basic-addon1">No.C</span>
                                            </div>
                                            <input type="text" className="form-control input-sm" id="txtGroupCode" disabled={true}
                                                value={elementDoc.TypeDoc}
                                            />
                                        </div>
                                    </>
                                ))}
                            </div>

                            {/* SEGUNDA COLUMNA */}
                            <div className="col-12 col-md-6">
                                {(Number(action) === 2 && SearchedConsecutiveInfo) && sucursalModel.ConsecutiveDocs.slice(middleConsecutiveArray).map((elementDoc, index) => (
                                    <>
                                        <tr>
                                            <th colSpan={2}>{elementDoc.ThTitle}</th>
                                        </tr>
                                        <div className="input-group mb-3">
                                            <button
                                                type="button"
                                                style={{ backgroundColor: 'transparent', color: '#EABF28' }}
                                                className="input-group-text"
                                                onClick={() => UpgradeDocumentLoop(elementDoc)} >
                                                <i className="fa fa-arrow-up" aria-hidden="true" />
                                            </button>
                                            <div className="input-group-prepend">
                                                <span className="input-group-text font-weight-bold" id="basic-addon1">Loop</span>
                                            </div>
                                            <input type="text" className="form-control input-sm font-weight-bold" id="txtGroupCode" disabled={true}
                                                value={elementDoc.TypeDocLoop ?? 0}
                                            />
                                            <div className="input-group-prepend">
                                                <span className="input-group-text font-weight-bold" id="basic-addon1">No.C</span>
                                            </div>
                                            <input type="text" className="form-control input-sm" id="txtGroupCode" disabled={true}
                                                value={elementDoc.TypeDoc ?? 0}
                                            />
                                        </div>
                                    </>
                                ))}
                            </div>
                        </div>
                    </div>
                    {/* SERIES Y CORRELATIVOS VENTA EN PLANTA */}
                    <div className="tab-pane" id="seriesAndConsecutives" aria-labelledby="nav-profile-tab-consecutives">
                        <div className="row">
                            {documentTypeSeries?.map((item, index) => (

                                <div key={index} className="col-12 col-md-6 mb-3">
                                    <div className="input-group mb-3">
                                        <div className="input-group-prepend">
                                            <span className="input-group-text font-weight-bold" id={`SERIES-SPAN-${item.Code}`}>{item?.U_BPP_TDDD ?? ''}</span>
                                        </div>
                                        <input type="text" className="form-control input-sm"
                                            id={`SERIES-${item.Code}`}
                                            disabled={true}
                                            value={sucursalModel?.U_FMB_ValidateSeriesSUNAT?.[item.Code] ?? ''}
                                        />

                                        <button
                                            type="button"
                                            style={{ backgroundColor: 'transparent', color: '#EABF28' }}
                                            className="input-group-text"
                                            onClick={() => OpenSeriesModal('SERIES', sucursalModel?.U_FMB_ValidateSeriesSUNAT?.[item.Code] ?? '', item.Code)}
                                        >
                                            <i className="fa fa-list" aria-hidden="true" />
                                        </button>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>

                    {/* SERIES Y CORRELATIVOS  VENTA EN PUERTA*/}
                    <div className="tab-pane" id="seriesAndconsecutivesPUERTA" aria-labelledby="nav-profile-tab-consecutivesPUERTA">
                        <div className="row">
                            {documentTypeSeries?.map((item, index) => (

                                <div key={index} className="col-12 col-md-6 mb-3">
                                    <div className="input-group mb-3">
                                        <div className="input-group-prepend">
                                            <span className="input-group-text font-weight-bold" id={`SERIES-SPAN-${item.Code}`}>{item?.U_BPP_TDDD ?? ''}</span>
                                        </div>
                                        <input type="text" className="form-control input-sm"
                                            id={`SERIES-${item.Code}`}
                                            disabled={true}
                                            value={sucursalModel?.U_FMB_ValidateSeriesPUERTA?.[item.Code] ?? ''}
                                        />

                                        <button
                                            type="button"
                                            style={{ backgroundColor: 'transparent', color: '#EABF28' }}
                                            className="input-group-text"
                                            onClick={() => OpenSeriesModal('SERIESPUERTA', sucursalModel?.U_FMB_ValidateSeriesPUERTA?.[item.Code] ?? '', item.Code)}
                                        >
                                            <i className="fa fa-list" aria-hidden="true" />
                                        </button>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>

                </div>
            </div>
        )
    }

    bodyAddPaymentMethod = () => {
        const { PayMethodModel, SAPCards } = this.props
        return (
            <div className="container">
                <div className="row justify-content-around">
                    <div className="col-12">
                        <div className="row" style={{ paddingRight: 0 }} autoComplete="off">
                            <div className="col-12 col-md-6">
                                {/* CODE PAYMENTMETHOD*/}
                                <div className="input-group mb-3">
                                    <div className="input-group-prepend">
                                        <span className="input-group-text font-weight-bold" id="basic-addon1">Código</span>
                                    </div>
                                    <input type="text" className="form-control"
                                        style={{ backgroundColor: 'transparent', borderColor: '#ced4da', color: '#000' }}
                                        onChange={(event) => this.ChangeCodeNewPayMethod(event.target.value)}
                                        disabled={(PayMethodModel && (PayMethodModel.code === 'NC' || PayMethodModel.code === 'CD')) ? true : false}
                                        value={!!PayMethodModel ? PayMethodModel.code : ""} />
                                </div>
                                {/* NAME PAYMENTMETHOD*/}
                                <div className="input-group mb-3">
                                    <div className="input-group-prepend">
                                        <span className="input-group-text font-weight-bold" id="basic-addon1">Nombre</span>
                                    </div>
                                    <input type="text" className="form-control"
                                        style={{ backgroundColor: 'transparent', borderColor: '#ced4da', color: '#000' }}
                                        onChange={(event) => this.ChangeNameNewPayMethod(event.target.value)}
                                        disabled={(PayMethodModel && (PayMethodModel.code === 'NC' || PayMethodModel.code === 'CD')) ? true : false}
                                        value={!!PayMethodModel ? PayMethodModel.name : ""} />
                                </div>

                            </div>
                            <div className="col-12 col-md-6">
                                {/* TYPE PAYMENTMETHOD*/}
                                <div className="input-group mb-3">
                                    <div className="input-group-prepend">
                                        <span className="input-group-text font-weight-bold" id="basic-addon1">Tipo de pago</span>
                                    </div>
                                    <select
                                        name="select"
                                        className="form-control"
                                        style={{ color: "#000", borderRadius: 4, backgroundColor: "transparent", height: 40 }}
                                        value={PayMethodModel ? PayMethodModel.type : ''}
                                        onChange={(event) => this.ChangeTypePayMethod(event.target.value)}
                                    >
                                        <option value="---">Seleccionar</option>
                                        <option value={0}>Efectivo</option>
                                        <option value={1}>Cheque</option>
                                        <option value={2}>Tarjeta</option>

                                        <option value={3}>Transferencia</option>
                                        <option value={4}>Devolución</option>
                                        <option value={14}>Nota de crédito</option>
                                        <option value={124}>FISE</option>
                                        <option value={125}>Niubiz</option>
                                        <option value={-1}>Crédito</option>

                                    </select>
                                </div>
                                {PayMethodModel && Number(PayMethodModel.type) === 2 &&
                                    <div className="input-group mb-3">
                                        <div className="input-group-prepend">
                                            <span className="input-group-text font-weight-bold" id="basic-addon1">Tarjeta</span>
                                        </div>
                                        <select
                                            name="select"
                                            className="form-control"
                                            style={{ color: "#000", borderRadius: 4, backgroundColor: "transparent", height: 40 }}
                                            value={PayMethodModel ? PayMethodModel.idCard : ''}
                                            onChange={(event) => this.ChangeCard(event.target.value)}
                                        >
                                            <option value="">Seleccionar tarjeta</option>
                                            {!!SAPCards && SAPCards.map(card => {
                                                return (
                                                    <option value={card.CreditCard}>{card.CardName} - {card.AcctCode}</option>
                                                )
                                            })}
                                        </select>
                                    </div>
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    footerAddPayMehtod = () => {
        const { SendPayMethodModel } = this.props;
        return (
            <div>
                {/* <button type="button" className="btn btn-outline-success" onClick={() => ShowRelatedPMBO()}>mostarra</button> */}
                <button type="button" className="btn botonCorrect" onClick={() => SendPayMethodModel()}>Agregar</button>
            </div>
        )
    }
}

const mapStateToProps = store => {
    return { notificationReducer: store.NotificationReducer };
};

const mapDispatchToProps = dispatch => {
    return {
        enableSpinner: value => dispatch({ type: DISPATCH_ID.CONFIG_SET_SPINNER, value })
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(SucursalModal);

